// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../libs/ui/src/lib/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.18 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: var(--font-sans), ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

*{
  border-color: hsl(var(--border));
}

html{
  min-height: 100vh;
}

body{
  min-height: 100vh;
  background-color: transparent;
  color: hsl(var(--foreground));
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

:root {
    --bg: var(--sm-bg-page);
    --surface: var(--sm-surface);
    --surface-2: var(--sm-surface-muted);
    --border: var(--sm-border);
    --text: var(--sm-text);
    --text-muted: var(--sm-text-muted);
    --primary: var(--sm-primary);
    --primary-foreground: #ffffff;
    --danger: var(--sm-danger);
    --ring: var(--sm-focus);
    --muted-foreground: 220 18% 40%;
    --sm-bg-page: linear-gradient(180deg, #f8fbff 0%, #eef4ff 55%, #f8fbff 100%),
      radial-gradient(1200px circle at 25% -10%, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0) 60%),
      radial-gradient(900px circle at 75% 110%, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0) 60%);
    --sm-surface: #ffffff;
    --sm-surface-muted: #f2f5fb;
    --sm-panel: #0b1220;
    --sm-panel-2: #111a2b;
    --sm-text: #0b1220;
    --sm-text-muted: #5b6b85;
    --sm-text-on-panel: #f8fafc;
    --sm-text-on-panel-muted: #c5d0e5;
    --sm-border: rgba(15, 23, 42, 0.08);
    --sm-border-on-panel: rgba(148, 163, 184, 0.28);
    --sm-primary: #1d4ed8;
    --sm-danger: #e11d48;
    --sm-focus: rgba(59, 130, 246, 0.5);
  }

.dark {
    --bg: var(--sm-bg-page);
    --surface: var(--sm-surface);
    --surface-2: var(--sm-surface-muted);
    --border: var(--sm-border);
    --text: var(--sm-text);
    --text-muted: var(--sm-text-muted);
    --primary: var(--sm-primary);
    --primary-foreground: #ffffff;
    --danger: var(--sm-danger);
    --ring: var(--sm-focus);
    --muted-foreground: 214 20% 74%;
    --sm-bg-page: radial-gradient(circle at top, #0b1222, #0b1222 45%, #060914 100%);
    --sm-surface: #0f172a;
    --sm-surface-muted: #111b2f;
    --sm-panel: #0b111e;
    --sm-panel-2: #0f182a;
    --sm-text: #f8fafc;
    --sm-text-muted: #c0cadb;
    --sm-text-on-panel: #f8fafc;
    --sm-text-on-panel-muted: #c0cadb;
    --sm-border: rgba(148, 163, 184, 0.25);
    --sm-border-on-panel: rgba(148, 163, 184, 0.3);
    --sm-primary: #3b82f6;
    --sm-danger: #fb7185;
    --sm-focus: rgba(96, 165, 250, 0.55);
  }
.\\!container{
  width: 100% !important;
  margin-right: auto !important;
  margin-left: auto !important;
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}
.container{
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 1.5rem;
  padding-left: 1.5rem;
}
@media (min-width: 1400px){

  .\\!container{
    max-width: 1400px !important;
  }

  .container{
    max-width: 1400px;
  }
}
.sm-page{
  min-height: 100vh;
  background-color: var(--sm-bg-page);
  color: var(--sm-text);
}
.sm-container{
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 72rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 4rem;
  padding-top: 1.5rem;
}
@media (min-width: 640px){

  .sm-container{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
@media (min-width: 1024px){

  .sm-container{
    max-width: 80rem;
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
.sm-surface-card{
  border-radius: 20px;
  border-width: 1px;
  border-color: var(--sm-border);
  background-color: var(--sm-surface);
  color: var(--sm-text);
  --tw-shadow: 0 18px 45px rgba(15,23,42,0.08);
  --tw-shadow-colored: 0 18px 45px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.sm-surface-muted{
  border-radius: 18px;
  border-width: 1px;
  border-color: var(--sm-border);
  background-color: var(--sm-surface-muted);
  color: var(--sm-text);
}
.sm-panel-card{
  border-radius: 20px;
  border-width: 1px;
  border-color: var(--sm-border-on-panel);
  background-color: var(--sm-panel);
  color: var(--sm-text-on-panel);
  --tw-shadow: 0 20px 50px rgba(3,7,18,0.38);
  --tw-shadow-colored: 0 20px 50px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.sm-panel-card-muted{
  border-radius: 18px;
  border-width: 1px;
  border-color: var(--sm-border-on-panel);
  background-color: var(--sm-panel-2);
  color: var(--sm-text-on-panel);
}
.sm-section-header{
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.sm-section-eyebrow{
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.32em;
  color: var(--sm-text-muted);
}
.sm-section-title{
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 600;
  color: var(--sm-text);
}
.sm-section-subtitle{
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--sm-text-muted);
}
.sm-btn-primary{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background-color: var(--sm-primary);
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 12px 24px rgba(30,64,175,0.35);
  --tw-shadow-colored: 0 12px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.sm-btn-primary:hover{
  --tw-brightness: brightness(1.1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.sm-btn-primary:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: var(--sm-focus);
}
.sm-btn-primary:disabled{
  cursor: not-allowed;
  opacity: 0.6;
}
.sm-btn-secondary{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border-width: 1px;
  border-color: var(--sm-border);
  background-color: var(--sm-surface-muted);
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  color: var(--sm-text);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.sm-btn-secondary:hover{
  --tw-brightness: brightness(1.05);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.sm-btn-secondary:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: var(--sm-focus);
}
.sm-btn-secondary:disabled{
  cursor: not-allowed;
  opacity: 0.6;
}
.sm-btn-secondary-panel{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border-width: 1px;
  border-color: var(--sm-border-on-panel);
  background-color: var(--sm-panel-2);
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  color: var(--sm-text-on-panel);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.sm-btn-secondary-panel:hover{
  --tw-brightness: brightness(1.1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.sm-btn-secondary-panel:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: var(--sm-focus);
}
.sm-btn-secondary-panel:disabled{
  cursor: not-allowed;
  opacity: 0.6;
}
.sm-btn-ghost{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  color: var(--sm-text-muted);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.sm-btn-ghost:hover{
  background-color: var(--sm-surface-muted);
  color: var(--sm-text);
}
.sm-btn-ghost:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: var(--sm-focus);
}
.sm-btn-danger{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background-color: var(--sm-danger);
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 12px 24px rgba(225,29,72,0.28);
  --tw-shadow-colored: 0 12px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.sm-btn-danger:hover{
  --tw-brightness: brightness(1.1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.sm-btn-danger:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: var(--sm-focus);
}
.sm-btn-danger:disabled{
  cursor: not-allowed;
  opacity: 0.6;
}
.sm-input{
  height: 2.75rem;
  border-radius: 14px;
  border-width: 1px;
  border-color: var(--sm-border);
  background-color: var(--sm-surface);
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--sm-text);
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.sm-input::-moz-placeholder{
  color: var(--sm-text-muted);
}
.sm-input::placeholder{
  color: var(--sm-text-muted);
}
.sm-input:focus-visible{
  border-color: var(--sm-primary);
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: var(--sm-focus);
}
.sm-textarea{
  min-height: 120px;
  border-radius: 16px;
  border-width: 1px;
  border-color: var(--sm-border);
  background-color: var(--sm-surface);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--sm-text);
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.sm-textarea::-moz-placeholder{
  color: var(--sm-text-muted);
}
.sm-textarea::placeholder{
  color: var(--sm-text-muted);
}
.sm-textarea:focus-visible{
  border-color: var(--sm-primary);
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: var(--sm-focus);
}
.sm-select{
  height: 2.75rem;
  border-radius: 14px;
  border-width: 1px;
  border-color: var(--sm-border);
  background-color: var(--sm-surface);
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--sm-text);
}
.sm-select:focus-visible{
  border-color: var(--sm-primary);
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: var(--sm-focus);
}
.sm-pill{
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 9999px;
  border-width: 1px;
  border-color: var(--sm-border);
  background-color: var(--sm-surface-muted);
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
  color: var(--sm-text);
}
.sm-row{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  border-radius: 18px;
  border-width: 1px;
  border-color: var(--sm-border);
  background-color: var(--sm-surface);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--sm-text);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.sm-row:hover{
  --tw-shadow: 0 12px 26px rgba(15,23,42,0.12);
  --tw-shadow-colored: 0 12px 26px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.sm-empty{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 20px;
  border-width: 1px;
  border-style: dashed;
  border-color: var(--sm-border);
  background-color: var(--sm-surface-muted);
  padding: 1.5rem;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--sm-text-muted);
}
.sm-modal{
  border-radius: 22px;
  border-width: 1px;
  border-color: var(--sm-border);
  background-color: var(--sm-surface);
  padding: 1.5rem;
  color: var(--sm-text);
  --tw-shadow: 0 28px 80px rgba(15,23,42,0.2);
  --tw-shadow-colored: 0 28px 80px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.not-sr-only{
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.-inset-1{
  inset: -0.25rem;
}
.inset-0{
  inset: 0px;
}
.inset-2{
  inset: 0.5rem;
}
.inset-4{
  inset: 1rem;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-10{
  bottom: -2.5rem;
}
.-bottom-16{
  bottom: -4rem;
}
.-left-10{
  left: -2.5rem;
}
.-left-12{
  left: -3rem;
}
.-left-32{
  left: -8rem;
}
.-right-16{
  right: -4rem;
}
.-right-24{
  right: -6rem;
}
.-right-4{
  right: -1rem;
}
.-top-36{
  top: -9rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-10{
  bottom: 2.5rem;
}
.bottom-12{
  bottom: 3rem;
}
.bottom-16{
  bottom: 4rem;
}
.bottom-20{
  bottom: 5rem;
}
.bottom-3{
  bottom: 0.75rem;
}
.bottom-4{
  bottom: 1rem;
}
.bottom-6{
  bottom: 1.5rem;
}
.left-0{
  left: 0px;
}
.left-1{
  left: 0.25rem;
}
.left-10{
  left: 2.5rem;
}
.left-14{
  left: 3.5rem;
}
.left-16{
  left: 4rem;
}
.left-2{
  left: 0.5rem;
}
.left-20{
  left: 5rem;
}
.left-3{
  left: 0.75rem;
}
.left-3\\.5{
  left: 0.875rem;
}
.left-4{
  left: 1rem;
}
.left-5{
  left: 1.25rem;
}
.left-6{
  left: 1.5rem;
}
.left-\\[50\\%\\]{
  left: 50%;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-1\\.5{
  right: 0.375rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-1\\.5{
  top: 0.375rem;
}
.top-1\\/2{
  top: 50%;
}
.top-10{
  top: 2.5rem;
}
.top-2{
  top: 0.5rem;
}
.top-20{
  top: 5rem;
}
.top-24{
  top: 6rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-6{
  top: 1.5rem;
}
.top-8{
  top: 2rem;
}
.top-\\[1px\\]{
  top: 1px;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[60\\%\\]{
  top: 60%;
}
.top-full{
  top: 100%;
}
.isolate{
  isolation: isolate;
}
.isolation-auto{
  isolation: auto;
}
.-z-10{
  z-index: -10;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[1000\\]{
  z-index: 1000;
}
.z-\\[1\\]{
  z-index: 1;
}
.order-1{
  order: 1;
}
.order-2{
  order: 2;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.col-span-full{
  grid-column: 1 / -1;
}
.m-0{
  margin: 0px;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-2{
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.mx-6{
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mx-7{
  margin-left: 1.75rem;
  margin-right: 1.75rem;
}
.mx-8{
  margin-left: 2rem;
  margin-right: 2rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.\\!mt-0{
  margin-top: 0px !important;
}
.-ml-16{
  margin-left: -4rem;
}
.-ml-20{
  margin-left: -5rem;
}
.-ml-24{
  margin-left: -6rem;
}
.-ml-28{
  margin-left: -7rem;
}
.-ml-36{
  margin-left: -9rem;
}
.-ml-40{
  margin-left: -10rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.me-1{
  margin-inline-end: 0.25rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-1\\.5{
  margin-left: 0.375rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-1\\.5{
  margin-right: 0.375rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mt-0{
  margin-top: 0px;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-2\\.5{
  margin-top: 0.625rem;
}
.mt-20{
  margin-top: 5rem;
}
.mt-24{
  margin-top: 6rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-3\\.5{
  margin-top: 0.875rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-7{
  margin-top: 1.75rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-auto{
  margin-top: auto;
}
.line-clamp-1{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.\\!block{
  display: block !important;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.inline-table{
  display: inline-table;
}
.table-caption{
  display: table-caption;
}
.table-cell{
  display: table-cell;
}
.table-column{
  display: table-column;
}
.table-column-group{
  display: table-column-group;
}
.table-footer-group{
  display: table-footer-group;
}
.table-header-group{
  display: table-header-group;
}
.table-row-group{
  display: table-row-group;
}
.table-row{
  display: table-row;
}
.flow-root{
  display: flow-root;
}
.grid{
  display: grid;
}
.inline-grid{
  display: inline-grid;
}
.contents{
  display: contents;
}
.list-item{
  display: list-item;
}
.hidden{
  display: none;
}
.aspect-\\[4\\/3\\]{
  aspect-ratio: 4/3;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.size-4{
  width: 1rem;
  height: 1rem;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-72{
  height: 18rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-96{
  height: 24rem;
}
.h-\\[120\\%\\]{
  height: 120%;
}
.h-\\[18px\\]{
  height: 18px;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[40px\\]{
  height: 40px;
}
.h-\\[420px\\]{
  height: 420px;
}
.h-\\[46px\\]{
  height: 46px;
}
.h-\\[520px\\]{
  height: 520px;
}
.h-\\[640px\\]{
  height: 640px;
}
.h-\\[90\\%\\]{
  height: 90%;
}
.h-\\[min\\(94vh\\2c 1120px\\)\\]{
  height: min(94vh,1120px);
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\]{
  height: var(--radix-navigation-menu-viewport-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\]{
  height: var(--radix-select-trigger-height);
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-48{
  max-height: 12rem;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-\\[--radix-select-content-available-height\\]{
  max-height: var(--radix-select-content-available-height);
}
.max-h-\\[240px\\]{
  max-height: 240px;
}
.max-h-\\[320px\\]{
  max-height: 320px;
}
.max-h-\\[420px\\]{
  max-height: 420px;
}
.max-h-\\[46vh\\]{
  max-height: 46vh;
}
.max-h-\\[60vh\\]{
  max-height: 60vh;
}
.max-h-\\[720px\\]{
  max-height: 720px;
}
.max-h-\\[75vh\\]{
  max-height: 75vh;
}
.max-h-\\[82vh\\]{
  max-height: 82vh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[min\\(58vh\\2c 620px\\)\\]{
  max-height: min(58vh,620px);
}
.max-h-\\[var\\(--radix-dropdown-menu-content-available-height\\)\\]{
  max-height: var(--radix-dropdown-menu-content-available-height);
}
.max-h-full{
  max-height: 100%;
}
.min-h-0{
  min-height: 0px;
}
.min-h-\\[104px\\]{
  min-height: 104px;
}
.min-h-\\[120px\\]{
  min-height: 120px;
}
.min-h-\\[280px\\]{
  min-height: 280px;
}
.min-h-\\[40px\\]{
  min-height: 40px;
}
.min-h-\\[60vh\\]{
  min-height: 60vh;
}
.min-h-\\[70px\\]{
  min-height: 70px;
}
.min-h-\\[760px\\]{
  min-height: 760px;
}
.min-h-\\[80px\\]{
  min-height: 80px;
}
.min-h-\\[92px\\]{
  min-height: 92px;
}
.min-h-\\[96px\\]{
  min-height: 96px;
}
.min-h-\\[calc\\(100vh-112px\\)\\]{
  min-height: calc(100vh - 112px);
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.w-0{
  width: 0px;
}
.w-1{
  width: 0.25rem;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-40{
  width: 10rem;
}
.w-44{
  width: 11rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-52{
  width: 13rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[170px\\]{
  width: 170px;
}
.w-\\[18px\\]{
  width: 18px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-\\[220px\\]{
  width: 220px;
}
.w-\\[260px\\]{
  width: 260px;
}
.w-\\[40\\%\\]{
  width: 40%;
}
.w-\\[420px\\]{
  width: 420px;
}
.w-\\[520px\\]{
  width: 520px;
}
.w-\\[55\\%\\]{
  width: 55%;
}
.w-\\[640px\\]{
  width: 640px;
}
.w-\\[72px\\]{
  width: 72px;
}
.w-\\[88\\%\\]{
  width: 88%;
}
.w-\\[calc\\(100\\%-2rem\\)\\]{
  width: calc(100% - 2rem);
}
.w-\\[min\\(94vw\\2c 1040px\\)\\]{
  width: min(94vw,1040px);
}
.w-\\[var\\(--radix-popover-trigger-width\\)\\]{
  width: var(--radix-popover-trigger-width);
}
.w-auto{
  width: auto;
}
.w-fit{
  width: -moz-fit-content;
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: -moz-max-content;
  width: max-content;
}
.min-w-0{
  min-width: 0px;
}
.min-w-10{
  min-width: 2.5rem;
}
.min-w-11{
  min-width: 2.75rem;
}
.min-w-24{
  min-width: 6rem;
}
.min-w-9{
  min-width: 2.25rem;
}
.min-w-\\[132px\\]{
  min-width: 132px;
}
.min-w-\\[140px\\]{
  min-width: 140px;
}
.min-w-\\[150px\\]{
  min-width: 150px;
}
.min-w-\\[170px\\]{
  min-width: 170px;
}
.min-w-\\[220px\\]{
  min-width: 220px;
}
.min-w-\\[280px\\]{
  min-width: 280px;
}
.min-w-\\[8rem\\]{
  min-width: 8rem;
}
.min-w-\\[980px\\]{
  min-width: 980px;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
  min-width: var(--radix-select-trigger-width);
}
.min-w-max{
  min-width: -moz-max-content;
  min-width: max-content;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[1120px\\]{
  max-width: 1120px;
}
.max-w-\\[1180px\\]{
  max-width: 1180px;
}
.max-w-\\[1200px\\]{
  max-width: 1200px;
}
.max-w-\\[18ch\\]{
  max-width: 18ch;
}
.max-w-\\[220px\\]{
  max-width: 220px;
}
.max-w-\\[24ch\\]{
  max-width: 24ch;
}
.max-w-\\[260px\\]{
  max-width: 260px;
}
.max-w-\\[295px\\]{
  max-width: 295px;
}
.max-w-\\[320px\\]{
  max-width: 320px;
}
.max-w-\\[360px\\]{
  max-width: 360px;
}
.max-w-\\[380px\\]{
  max-width: 380px;
}
.max-w-\\[420px\\]{
  max-width: 420px;
}
.max-w-\\[490px\\]{
  max-width: 490px;
}
.max-w-\\[500px\\]{
  max-width: 500px;
}
.max-w-\\[520px\\]{
  max-width: 520px;
}
.max-w-\\[540px\\]{
  max-width: 540px;
}
.max-w-\\[80\\%\\]{
  max-width: 80%;
}
.max-w-\\[85\\%\\]{
  max-width: 85%;
}
.max-w-\\[90\\%\\]{
  max-width: 90%;
}
.max-w-\\[96\\%\\]{
  max-width: 96%;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-max{
  max-width: -moz-max-content;
  max-width: max-content;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.flex-1{
  flex: 1 1 0%;
}
.flex-shrink{
  flex-shrink: 1;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.grow{
  flex-grow: 1;
}
.caption-bottom{
  caption-side: bottom;
}
.border-collapse{
  border-collapse: collapse;
}
.origin-\\[--radix-dropdown-menu-content-transform-origin\\]{
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}
.origin-\\[--radix-popover-content-transform-origin\\]{
  transform-origin: var(--radix-popover-content-transform-origin);
}
.origin-\\[--radix-select-content-transform-origin\\]{
  transform-origin: var(--radix-select-content-transform-origin);
}
.origin-\\[--radix-tooltip-content-transform-origin\\]{
  transform-origin: var(--radix-tooltip-content-transform-origin);
}
.-translate-x-12{
  --tw-translate-x: -3rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-16{
  --tw-translate-x: -4rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-24{
  --tw-translate-x: -6rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-28{
  --tw-translate-x: -7rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-6{
  --tw-translate-x: -1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full{
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-0{
  --tw-translate-y: -0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-12{
  --tw-translate-y: -3rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-6{
  --tw-translate-y: -1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/4{
  --tw-translate-x: 25%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-24{
  --tw-translate-x: 6rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-6{
  --tw-translate-x: 1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-8{
  --tw-translate-x: 2rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-2{
  --tw-translate-y: 0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-3{
  --tw-translate-y: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-5{
  --tw-translate-y: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.touch-none{
  touch-action: none;
}
.touch-pinch-zoom{
  --tw-pinch-zoom: pinch-zoom;
  touch-action: var(--tw-pan-x) var(--tw-pan-y) var(--tw-pinch-zoom);
}
.select-none{
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.resize-none{
  resize: none;
}
.resize{
  resize: both;
}
.list-decimal{
  list-style-type: decimal;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5{
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-\\[2fr_1fr_1fr_1fr_1fr_140px\\]{
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr 140px;
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.flex-nowrap{
  flex-wrap: nowrap;
}
.place-content-center{
  place-content: center;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-0{
  gap: 0px;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-12 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(3rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(3rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-7 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.75rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.space-y-reverse > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 1;
}
.space-x-reverse > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 1;
}
.divide-x > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-y-reverse > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 1;
}
.divide-x-reverse > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 1;
}
.divide-slate-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-divide-opacity, 1));
}
.divide-slate-300 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-divide-opacity, 1));
}
.divide-slate-700 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-divide-opacity, 1));
}
.divide-slate-700\\/40 > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(51 65 85 / 0.4);
}
.self-start{
  align-self: flex-start;
}
.self-center{
  align-self: center;
}
.justify-self-end{
  justify-self: end;
}
.justify-self-center{
  justify-self: center;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-visible{
  overflow: visible;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overflow-y-visible{
  overflow-y: visible;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis{
  text-overflow: ellipsis;
}
.text-clip{
  text-overflow: clip;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.text-wrap{
  text-wrap: wrap;
}
.text-balance{
  text-wrap: balance;
}
.break-words{
  overflow-wrap: break-word;
}
.\\!rounded-none{
  border-radius: 0px !important;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[10px\\]{
  border-radius: 10px;
}
.rounded-\\[14px\\]{
  border-radius: 14px;
}
.rounded-\\[16px\\]{
  border-radius: 16px;
}
.rounded-\\[18px\\]{
  border-radius: 18px;
}
.rounded-\\[20px\\]{
  border-radius: 20px;
}
.rounded-\\[22px\\]{
  border-radius: 22px;
}
.rounded-\\[24px\\]{
  border-radius: 24px;
}
.rounded-\\[26px\\]{
  border-radius: 26px;
}
.rounded-\\[28px\\]{
  border-radius: 28px;
}
.rounded-\\[30px\\]{
  border-radius: 30px;
}
.rounded-\\[32px\\]{
  border-radius: 32px;
}
.rounded-\\[34px\\]{
  border-radius: 34px;
}
.rounded-\\[36px\\]{
  border-radius: 36px;
}
.rounded-\\[40px\\]{
  border-radius: 40px;
}
.rounded-\\[inherit\\]{
  border-radius: inherit;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: var(--radius);
}
.rounded-md{
  border-radius: calc(var(--radius) - 2px);
}
.rounded-none{
  border-radius: 0px;
}
.rounded-sm{
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b{
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-e{
  border-start-end-radius: 0.25rem;
  border-end-end-radius: 0.25rem;
}
.rounded-l{
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-r{
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.rounded-s{
  border-start-start-radius: 0.25rem;
  border-end-start-radius: 0.25rem;
}
.rounded-t{
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-\\[10px\\]{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-bl{
  border-bottom-left-radius: 0.25rem;
}
.rounded-br{
  border-bottom-right-radius: 0.25rem;
}
.rounded-ee{
  border-end-end-radius: 0.25rem;
}
.rounded-es{
  border-end-start-radius: 0.25rem;
}
.rounded-se{
  border-start-end-radius: 0.25rem;
}
.rounded-ss{
  border-start-start-radius: 0.25rem;
}
.rounded-tl{
  border-top-left-radius: 0.25rem;
}
.rounded-tl-sm{
  border-top-left-radius: calc(var(--radius) - 4px);
}
.rounded-tr{
  border-top-right-radius: 0.25rem;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-x{
  border-left-width: 1px;
  border-right-width: 1px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-y-0{
  border-top-width: 0px;
  border-bottom-width: 0px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-e{
  border-inline-end-width: 1px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-0{
  border-left-width: 0px;
}
.border-r{
  border-right-width: 1px;
}
.border-s{
  border-inline-start-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-dashed{
  border-style: dashed;
}
.border-none{
  border-style: none;
}
.border-\\[\\#9cbcff\\]{
  --tw-border-opacity: 1;
  border-color: rgb(156 188 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#cfdbff\\]{
  --tw-border-opacity: 1;
  border-color: rgb(207 219 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d7def5\\]{
  --tw-border-opacity: 1;
  border-color: rgb(215 222 245 / var(--tw-border-opacity, 1));
}
.border-\\[color\\:var\\(--sm-border\\)\\]{
  border-color: var(--sm-border);
}
.border-\\[color\\:var\\(--sm-border-on-panel\\)\\]{
  border-color: var(--sm-border-on-panel);
}
.border-\\[color\\:var\\(--sm-primary\\)\\]{
  border-color: var(--sm-primary);
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-500{
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-amber-900{
  --tw-border-opacity: 1;
  border-color: rgb(120 53 15 / var(--tw-border-opacity, 1));
}
.border-blue-100{
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
.border-blue-200{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-blue-200\\/80{
  border-color: rgb(191 219 254 / 0.8);
}
.border-blue-400{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.border-blue-500{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-border{
  border-color: hsl(var(--border));
}
.border-border\\/40{
  border-color: hsl(var(--border) / 0.4);
}
.border-border\\/60{
  border-color: hsl(var(--border) / 0.6);
}
.border-border\\/70{
  border-color: hsl(var(--border) / 0.7);
}
.border-border\\/80{
  border-color: hsl(var(--border) / 0.8);
}
.border-destructive{
  border-color: hsl(var(--destructive));
}
.border-destructive\\/50{
  border-color: hsl(var(--destructive) / 0.5);
}
.border-emerald-100{
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / var(--tw-border-opacity, 1));
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-200\\/80{
  border-color: rgb(167 243 208 / 0.8);
}
.border-emerald-400{
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity, 1));
}
.border-emerald-500{
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-fuchsia-200{
  --tw-border-opacity: 1;
  border-color: rgb(245 208 254 / var(--tw-border-opacity, 1));
}
.border-fuchsia-900{
  --tw-border-opacity: 1;
  border-color: rgb(112 26 117 / var(--tw-border-opacity, 1));
}
.border-input{
  border-color: hsl(var(--input));
}
.border-orange-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}
.border-orange-900{
  --tw-border-opacity: 1;
  border-color: rgb(124 45 18 / var(--tw-border-opacity, 1));
}
.border-primary{
  border-color: hsl(var(--primary));
}
.border-primary\\/10{
  border-color: hsl(var(--primary) / 0.1);
}
.border-primary\\/20{
  border-color: hsl(var(--primary) / 0.2);
}
.border-primary\\/30{
  border-color: hsl(var(--primary) / 0.3);
}
.border-primary\\/40{
  border-color: hsl(var(--primary) / 0.4);
}
.border-primary\\/50{
  border-color: hsl(var(--primary) / 0.5);
}
.border-primary\\/60{
  border-color: hsl(var(--primary) / 0.6);
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-400{
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-rose-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.border-rose-200\\/40{
  border-color: rgb(254 205 211 / 0.4);
}
.border-rose-200\\/60{
  border-color: rgb(254 205 211 / 0.6);
}
.border-rose-200\\/70{
  border-color: rgb(254 205 211 / 0.7);
}
.border-rose-200\\/80{
  border-color: rgb(254 205 211 / 0.8);
}
.border-rose-600{
  --tw-border-opacity: 1;
  border-color: rgb(225 29 72 / var(--tw-border-opacity, 1));
}
.border-rose-900{
  --tw-border-opacity: 1;
  border-color: rgb(136 19 55 / var(--tw-border-opacity, 1));
}
.border-sky-200{
  --tw-border-opacity: 1;
  border-color: rgb(186 230 253 / var(--tw-border-opacity, 1));
}
.border-sky-500{
  --tw-border-opacity: 1;
  border-color: rgb(14 165 233 / var(--tw-border-opacity, 1));
}
.border-slate-100{
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-slate-200\\/40{
  border-color: rgb(226 232 240 / 0.4);
}
.border-slate-200\\/50{
  border-color: rgb(226 232 240 / 0.5);
}
.border-slate-200\\/60{
  border-color: rgb(226 232 240 / 0.6);
}
.border-slate-200\\/70{
  border-color: rgb(226 232 240 / 0.7);
}
.border-slate-200\\/80{
  border-color: rgb(226 232 240 / 0.8);
}
.border-slate-200\\/90{
  border-color: rgb(226 232 240 / 0.9);
}
.border-slate-300{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-slate-700{
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
}
.border-slate-700\\/40{
  border-color: rgb(51 65 85 / 0.4);
}
.border-slate-700\\/60{
  border-color: rgb(51 65 85 / 0.6);
}
.border-slate-800{
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity, 1));
}
.border-slate-900{
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
}
.border-slate-900\\/50{
  border-color: rgb(15 23 42 / 0.5);
}
.border-transparent{
  border-color: transparent;
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/15{
  border-color: rgb(255 255 255 / 0.15);
}
.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/30{
  border-color: rgb(255 255 255 / 0.3);
}
.border-white\\/40{
  border-color: rgb(255 255 255 / 0.4);
}
.border-white\\/50{
  border-color: rgb(255 255 255 / 0.5);
}
.border-white\\/60{
  border-color: rgb(255 255 255 / 0.6);
}
.border-white\\/70{
  border-color: rgb(255 255 255 / 0.7);
}
.border-white\\/75{
  border-color: rgb(255 255 255 / 0.75);
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-t-transparent{
  border-top-color: transparent;
}
.bg-\\[\\#020824\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(2 8 36 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#040F2A\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(4 15 42 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#07163b\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(7 22 59 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0F265A\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(15 38 90 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0F265A\\]\\/10{
  background-color: rgb(15 38 90 / 0.1);
}
.bg-\\[\\#0b1d44\\]\\/50{
  background-color: rgb(11 29 68 / 0.5);
}
.bg-\\[\\#1E3A8A\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / var(--tw-bg-opacity, 1));
}
.bg-\\[color\\:var\\(--sm-danger\\)\\]{
  background-color: var(--sm-danger);
}
.bg-\\[color\\:var\\(--sm-panel\\)\\]{
  background-color: var(--sm-panel);
}
.bg-\\[color\\:var\\(--sm-panel-2\\)\\]{
  background-color: var(--sm-panel-2);
}
.bg-\\[color\\:var\\(--sm-primary\\)\\]{
  background-color: var(--sm-primary);
}
.bg-\\[color\\:var\\(--sm-surface\\)\\]{
  background-color: var(--sm-surface);
}
.bg-\\[color\\:var\\(--sm-surface-muted\\)\\]{
  background-color: var(--sm-surface-muted);
}
.bg-\\[var\\(--sm-bg-page\\)\\]{
  background-color: var(--sm-bg-page);
}
.bg-accent{
  background-color: hsl(var(--accent));
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-50\\/80{
  background-color: rgb(255 251 235 / 0.8);
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-950{
  --tw-bg-opacity: 1;
  background-color: rgb(69 26 3 / var(--tw-bg-opacity, 1));
}
.bg-background{
  background-color: hsl(var(--background));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-blue-600\\/10{
  background-color: rgb(37 99 235 / 0.1);
}
.bg-border{
  background-color: hsl(var(--border));
}
.bg-card{
  background-color: hsl(var(--card));
}
.bg-card\\/95{
  background-color: hsl(var(--card) / 0.95);
}
.bg-destructive{
  background-color: hsl(var(--destructive));
}
.bg-destructive\\/80{
  background-color: hsl(var(--destructive) / 0.8);
}
.bg-destructive\\/90{
  background-color: hsl(var(--destructive) / 0.9);
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400{
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50\\/80{
  background-color: rgb(236 253 245 / 0.8);
}
.bg-emerald-500{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-600{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-fuchsia-50{
  --tw-bg-opacity: 1;
  background-color: rgb(253 244 255 / var(--tw-bg-opacity, 1));
}
.bg-fuchsia-50\\/80{
  background-color: rgb(253 244 255 / 0.8);
}
.bg-fuchsia-500{
  --tw-bg-opacity: 1;
  background-color: rgb(217 70 239 / var(--tw-bg-opacity, 1));
}
.bg-fuchsia-950{
  --tw-bg-opacity: 1;
  background-color: rgb(74 4 78 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-muted{
  background-color: hsl(var(--muted));
}
.bg-muted\\/20{
  background-color: hsl(var(--muted) / 0.2);
}
.bg-muted\\/30{
  background-color: hsl(var(--muted) / 0.3);
}
.bg-muted\\/50{
  background-color: hsl(var(--muted) / 0.5);
}
.bg-orange-300{
  --tw-bg-opacity: 1;
  background-color: rgb(253 186 116 / var(--tw-bg-opacity, 1));
}
.bg-orange-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1));
}
.bg-orange-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-orange-50\\/80{
  background-color: rgb(255 247 237 / 0.8);
}
.bg-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-orange-950{
  --tw-bg-opacity: 1;
  background-color: rgb(67 20 7 / var(--tw-bg-opacity, 1));
}
.bg-popover{
  background-color: hsl(var(--popover));
}
.bg-primary{
  background-color: hsl(var(--primary));
}
.bg-primary\\/10{
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/15{
  background-color: hsl(var(--primary) / 0.15);
}
.bg-primary\\/5{
  background-color: hsl(var(--primary) / 0.05);
}
.bg-primary\\/80{
  background-color: hsl(var(--primary) / 0.8);
}
.bg-primary\\/90{
  background-color: hsl(var(--primary) / 0.9);
}
.bg-primary\\/\\[0\\.08\\]{
  background-color: hsl(var(--primary) / 0.08);
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-100\\/40{
  background-color: rgb(254 226 226 / 0.4);
}
.bg-red-100\\/70{
  background-color: rgb(254 226 226 / 0.7);
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-rose-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.bg-rose-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.bg-rose-50\\/70{
  background-color: rgb(255 241 242 / 0.7);
}
.bg-rose-50\\/80{
  background-color: rgb(255 241 242 / 0.8);
}
.bg-rose-500{
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.bg-rose-500\\/10{
  background-color: rgb(244 63 94 / 0.1);
}
.bg-rose-500\\/80{
  background-color: rgb(244 63 94 / 0.8);
}
.bg-rose-600{
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity, 1));
}
.bg-rose-950{
  --tw-bg-opacity: 1;
  background-color: rgb(76 5 25 / var(--tw-bg-opacity, 1));
}
.bg-rose-950\\/20{
  background-color: rgb(76 5 25 / 0.2);
}
.bg-secondary{
  background-color: hsl(var(--secondary));
}
.bg-secondary\\/80{
  background-color: hsl(var(--secondary) / 0.8);
}
.bg-sky-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}
.bg-sky-400{
  --tw-bg-opacity: 1;
  background-color: rgb(56 189 248 / var(--tw-bg-opacity, 1));
}
.bg-sky-400\\/30{
  background-color: rgb(56 189 248 / 0.3);
}
.bg-sky-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.bg-sky-500{
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity, 1));
}
.bg-sky-600{
  --tw-bg-opacity: 1;
  background-color: rgb(2 132 199 / var(--tw-bg-opacity, 1));
}
.bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-slate-300{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
.bg-slate-300\\/50{
  background-color: rgb(203 213 225 / 0.5);
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-50\\/60{
  background-color: rgb(248 250 252 / 0.6);
}
.bg-slate-50\\/70{
  background-color: rgb(248 250 252 / 0.7);
}
.bg-slate-50\\/80{
  background-color: rgb(248 250 252 / 0.8);
}
.bg-slate-600{
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}
.bg-slate-700{
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.bg-slate-700\\/70{
  background-color: rgb(51 65 85 / 0.7);
}
.bg-slate-700\\/80{
  background-color: rgb(51 65 85 / 0.8);
}
.bg-slate-800{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.bg-slate-800\\/80{
  background-color: rgb(30 41 59 / 0.8);
}
.bg-slate-900{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-slate-900\\/20{
  background-color: rgb(15 23 42 / 0.2);
}
.bg-slate-900\\/40{
  background-color: rgb(15 23 42 / 0.4);
}
.bg-slate-900\\/60{
  background-color: rgb(15 23 42 / 0.6);
}
.bg-slate-900\\/70{
  background-color: rgb(15 23 42 / 0.7);
}
.bg-slate-900\\/80{
  background-color: rgb(15 23 42 / 0.8);
}
.bg-slate-900\\/85{
  background-color: rgb(15 23 42 / 0.85);
}
.bg-slate-900\\/90{
  background-color: rgb(15 23 42 / 0.9);
}
.bg-slate-900\\/95{
  background-color: rgb(15 23 42 / 0.95);
}
.bg-slate-950{
  --tw-bg-opacity: 1;
  background-color: rgb(2 6 23 / var(--tw-bg-opacity, 1));
}
.bg-slate-950\\/20{
  background-color: rgb(2 6 23 / 0.2);
}
.bg-slate-950\\/55{
  background-color: rgb(2 6 23 / 0.55);
}
.bg-slate-950\\/60{
  background-color: rgb(2 6 23 / 0.6);
}
.bg-slate-950\\/75{
  background-color: rgb(2 6 23 / 0.75);
}
.bg-slate-950\\/95{
  background-color: rgb(2 6 23 / 0.95);
}
.bg-transparent{
  background-color: transparent;
}
.bg-violet-500{
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity, 1));
}
.bg-violet-500\\/25{
  background-color: rgb(139 92 246 / 0.25);
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15{
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/20{
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/5{
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/50{
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/55{
  background-color: rgb(255 255 255 / 0.55);
}
.bg-white\\/60{
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/70{
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/80{
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/85{
  background-color: rgb(255 255 255 / 0.85);
}
.bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/95{
  background-color: rgb(255 255 255 / 0.95);
}
.bg-\\[linear-gradient\\(135deg\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.95\\)\\2c rgba\\(238\\2c 244\\2c 255\\2c 0\\.9\\)\\)\\]{
  background-image: linear-gradient(135deg,rgba(255,255,255,0.95),rgba(238,244,255,0.9));
}
.bg-\\[linear-gradient\\(135deg\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.96\\)\\2c rgba\\(236\\2c 248\\2c 244\\2c 0\\.9\\)\\)\\]{
  background-image: linear-gradient(135deg,rgba(255,255,255,0.96),rgba(236,248,244,0.9));
}
.bg-\\[linear-gradient\\(180deg\\2c \\#7ea9ff\\2c \\#4f6bff\\)\\]{
  background-image: linear-gradient(180deg,#7ea9ff,#4f6bff);
}
.bg-\\[linear-gradient\\(180deg\\2c rgba\\(248\\2c 250\\2c 255\\2c 1\\)\\2c rgba\\(240\\2c 244\\2c 255\\2c 0\\.96\\)\\)\\]{
  background-image: linear-gradient(180deg,rgba(248,250,255,1),rgba(240,244,255,0.96));
}
.bg-\\[linear-gradient\\(180deg\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.98\\)\\2c rgba\\(247\\2c 249\\2c 255\\2c 0\\.95\\)\\)\\]{
  background-image: linear-gradient(180deg,rgba(255,255,255,0.98),rgba(247,249,255,0.95));
}
.bg-\\[linear-gradient\\(180deg\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.985\\)\\2c rgba\\(244\\2c 248\\2c 255\\2c 0\\.965\\)\\)\\]{
  background-image: linear-gradient(180deg,rgba(255,255,255,0.985),rgba(244,248,255,0.965));
}
.bg-\\[linear-gradient\\(180deg\\2c var\\(--sm-surface\\)\\2c var\\(--sm-surface-muted\\)\\)\\]{
  background-image: linear-gradient(180deg,var(--sm-surface),var(--sm-surface-muted));
}
.bg-\\[linear-gradient\\(90deg\\2c \\#1f378e\\2c \\#2f56ca_46\\%\\2c \\#63a2ff\\)\\]{
  background-image: linear-gradient(90deg,#1f378e,#2f56ca 46%,#63a2ff);
}
.bg-\\[radial-gradient\\(circle\\2c _rgba\\(0\\2c 0\\2c 0\\2c 0\\.28\\)\\2c _transparent_60\\%\\)\\]{
  background-image: radial-gradient(circle, rgba(0,0,0,0.28), transparent 60%);
}
.bg-\\[radial-gradient\\(circle\\2c _rgba\\(115\\2c 163\\2c 255\\2c 0\\.44\\)\\2c _rgba\\(97\\2c 140\\2c 255\\2c 0\\.08\\)_65\\%\\2c _transparent_78\\%\\)\\]{
  background-image: radial-gradient(circle, rgba(115,163,255,0.44), rgba(97,140,255,0.08) 65%, transparent 78%);
}
.bg-\\[radial-gradient\\(circle\\2c _rgba\\(255\\2c 255\\2c 255\\2c 0\\.18\\)\\2c _transparent_60\\%\\)\\]{
  background-image: radial-gradient(circle, rgba(255,255,255,0.18), transparent 60%);
}
.bg-\\[radial-gradient\\(circle_at_20\\%_20\\%\\2c _rgba\\(90\\2c 140\\2c 255\\2c 0\\.18\\)\\2c _transparent_40\\%\\)\\]{
  background-image: radial-gradient(circle at 20% 20%, rgba(90,140,255,0.18), transparent 40%);
}
.bg-\\[radial-gradient\\(circle_at_80\\%_30\\%\\2c _rgba\\(90\\2c 140\\2c 255\\2c 0\\.12\\)\\2c _transparent_38\\%\\)\\]{
  background-image: radial-gradient(circle at 80% 30%, rgba(90,140,255,0.12), transparent 38%);
}
.bg-\\[radial-gradient\\(circle_at_center\\2c _rgba\\(58\\2c 124\\2c 201\\2c 0\\.12\\)\\2c _rgba\\(247\\2c 250\\2c 255\\2c 1\\)\\)\\]{
  background-image: radial-gradient(circle at center, rgba(58,124,201,0.12), rgba(247,250,255,1));
}
.bg-\\[radial-gradient\\(circle_at_top\\2c _\\#eef3ff\\2c _\\#f6f8ff_45\\%\\2c _\\#e7eefc_100\\%\\)\\]{
  background-image: radial-gradient(circle at top, #eef3ff, #f6f8ff 45%, #e7eefc 100%);
}
.bg-\\[radial-gradient\\(circle_at_top\\2c _hsl\\(var\\(--primary\\)\\/0\\.18\\)\\2c _hsl\\(var\\(--background\\)\\)_65\\%\\)\\]{
  background-image: radial-gradient(circle at top, hsl(var(--primary)/0.18), hsl(var(--background)) 65%);
}
.bg-\\[radial-gradient\\(circle_at_top\\2c _hsla\\(221\\2c 71\\%\\2c 20\\%\\2c 0\\.25\\)\\2c _hsla\\(215\\2c 60\\%\\2c 98\\%\\2c 1\\)\\)\\]{
  background-image: radial-gradient(circle at top, hsla(221,71%,20%,0.25), hsla(215,60%,98%,1));
}
.bg-\\[radial-gradient\\(circle_at_top\\2c _rgba\\(58\\2c 124\\2c 201\\2c 0\\.08\\)\\2c _\\#f2f7ff\\)\\]{
  background-image: radial-gradient(circle at top, rgba(58,124,201,0.08), #f2f7ff);
}
.bg-\\[radial-gradient\\(circle_at_top\\2c _rgba\\(58\\2c 124\\2c 201\\2c 0\\.08\\)\\2c _rgba\\(247\\2c 250\\2c 255\\2c 1\\)\\)\\]{
  background-image: radial-gradient(circle at top, rgba(58,124,201,0.08), rgba(247,250,255,1));
}
.bg-\\[radial-gradient\\(circle_at_top\\2c _rgba\\(58\\2c 124\\2c 201\\2c 0\\.08\\)\\2c _rgba\\(255\\2c 255\\2c 255\\2c 0\\.9\\)\\)\\]{
  background-image: radial-gradient(circle at top, rgba(58,124,201,0.08), rgba(255,255,255,0.9));
}
.bg-\\[radial-gradient\\(circle_at_top\\2c _rgba\\(58\\2c 124\\2c 201\\2c 0\\.08\\)\\2c _rgba\\(255\\2c 255\\2c 255\\2c 0\\.95\\)\\)\\]{
  background-image: radial-gradient(circle at top, rgba(58,124,201,0.08), rgba(255,255,255,0.95));
}
.bg-\\[radial-gradient\\(circle_at_top\\2c _rgba\\(58\\2c 124\\2c 201\\2c 0\\.08\\)\\2c _rgba\\(255\\2c 255\\2c 255\\2c 0\\.98\\)\\)\\]{
  background-image: radial-gradient(circle at top, rgba(58,124,201,0.08), rgba(255,255,255,0.98));
}
.bg-\\[radial-gradient\\(circle_at_top\\2c _rgba\\(58\\2c 124\\2c 201\\2c 0\\.12\\)\\2c _\\#f4f7fb\\)\\]{
  background-image: radial-gradient(circle at top, rgba(58,124,201,0.12), #f4f7fb);
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-\\[\\#071538\\]{
  --tw-gradient-from: #071538 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(7 21 56 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#0A1E4B\\]{
  --tw-gradient-from: #0A1E4B var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(10 30 75 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#0A1F4C\\]{
  --tw-gradient-from: #0A1F4C var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(10 31 76 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#0F265A\\]{
  --tw-gradient-from: #0F265A var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 38 90 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#102f6a\\]{
  --tw-gradient-from: #102f6a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 47 106 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#1ecad3\\]{
  --tw-gradient-from: #1ecad3 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 202 211 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#E8F4FA\\]{
  --tw-gradient-from: #E8F4FA var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(232 244 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary{
  --tw-gradient-from: hsl(var(--primary)) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary\\/10{
  --tw-gradient-from: hsl(var(--primary) / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary\\/15{
  --tw-gradient-from: hsl(var(--primary) / 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary\\/5{
  --tw-gradient-from: hsl(var(--primary) / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-50{
  --tw-gradient-from: #faf5ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 245 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-500{
  --tw-gradient-from: #0ea5e9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(14 165 233 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-500\\/20{
  --tw-gradient-from: rgb(14 165 233 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(14 165 233 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-50{
  --tw-gradient-from: #f8fafc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-900{
  --tw-gradient-from: #0f172a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-950{
  --tw-gradient-from: #020617 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(2 6 23 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-500{
  --tw-gradient-from: #8b5cf6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-500\\/30{
  --tw-gradient-from: rgb(139 92 246 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white{
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white\\/90{
  --tw-gradient-from: rgb(255 255 255 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#040b1f\\]{
  --tw-gradient-to: rgb(4 11 31 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #040b1f var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#0A1F4C\\]{
  --tw-gradient-to: rgb(10 31 76 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0A1F4C var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#122E63\\]{
  --tw-gradient-to: rgb(18 46 99 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #122E63 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#12b2c7\\]{
  --tw-gradient-to: rgb(18 178 199 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #12b2c7 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#1544A4\\]{
  --tw-gradient-to: rgb(21 68 164 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #1544A4 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#1f3c82\\]{
  --tw-gradient-to: rgb(31 60 130 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #1f3c82 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-cyan-400{
  --tw-gradient-to: rgb(34 211 238 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #22d3ee var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-cyan-400\\/20{
  --tw-gradient-to: rgb(34 211 238 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(34 211 238 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-primary{
  --tw-gradient-to: hsl(var(--primary) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--primary)) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-500{
  --tw-gradient-to: rgb(168 85 247 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #a855f7 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-500\\/30{
  --tw-gradient-to: rgb(168 85 247 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(168 85 247 / 0.3) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-slate-900{
  --tw-gradient-to: rgb(15 23 42 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0f172a var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white\\/80{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.8) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#01030b\\]{
  --tw-gradient-to: #01030b var(--tw-gradient-to-position);
}
.to-\\[\\#041230\\]{
  --tw-gradient-to: #041230 var(--tw-gradient-to-position);
}
.to-\\[\\#0f99c6\\]{
  --tw-gradient-to: #0f99c6 var(--tw-gradient-to-position);
}
.to-\\[\\#1B3B7F\\]{
  --tw-gradient-to: #1B3B7F var(--tw-gradient-to-position);
}
.to-\\[\\#1f3c82\\]{
  --tw-gradient-to: #1f3c82 var(--tw-gradient-to-position);
}
.to-\\[\\#2357bd\\]{
  --tw-gradient-to: #2357bd var(--tw-gradient-to-position);
}
.to-\\[\\#3157ac\\]{
  --tw-gradient-to: #3157ac var(--tw-gradient-to-position);
}
.to-\\[\\#3B7BFF\\]{
  --tw-gradient-to: #3B7BFF var(--tw-gradient-to-position);
}
.to-\\[\\#eef3ff\\]{
  --tw-gradient-to: #eef3ff var(--tw-gradient-to-position);
}
.to-\\[\\#eef3ff\\]\\/80{
  --tw-gradient-to: rgb(238 243 255 / 0.8) var(--tw-gradient-to-position);
}
.to-\\[color\\:var\\(--sm-surface-muted\\)\\]{
  --tw-gradient-to: var(--sm-surface-muted) var(--tw-gradient-to-position);
}
.to-blue-50{
  --tw-gradient-to: #eff6ff var(--tw-gradient-to-position);
}
.to-primary{
  --tw-gradient-to: hsl(var(--primary)) var(--tw-gradient-to-position);
}
.to-primary\\/5{
  --tw-gradient-to: hsl(var(--primary) / 0.05) var(--tw-gradient-to-position);
}
.to-slate-200{
  --tw-gradient-to: #e2e8f0 var(--tw-gradient-to-position);
}
.to-slate-50{
  --tw-gradient-to: #f8fafc var(--tw-gradient-to-position);
}
.to-slate-900{
  --tw-gradient-to: #0f172a var(--tw-gradient-to-position);
}
.to-slate-900\\/40{
  --tw-gradient-to: rgb(15 23 42 / 0.4) var(--tw-gradient-to-position);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-white{
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.bg-repeat{
  background-repeat: repeat;
}
.fill-current{
  fill: currentColor;
}
.object-contain{
  -o-object-fit: contain;
     object-fit: contain;
}
.object-cover{
  -o-object-fit: cover;
     object-fit: cover;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-12{
  padding: 3rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[1px\\]{
  padding: 1px;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-12{
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-14{
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}
.px-16{
  padding-left: 4rem;
  padding-right: 4rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-20{
  padding-left: 5rem;
  padding-right: 5rem;
}
.px-24{
  padding-left: 6rem;
  padding-right: 6rem;
}
.px-28{
  padding-left: 7rem;
  padding-right: 7rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-9{
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-1\\.5{
  padding-bottom: 0.375rem;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-12{
  padding-bottom: 3rem;
}
.pb-16{
  padding-bottom: 4rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-7{
  padding-bottom: 1.75rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-11{
  padding-left: 2.75rem;
}
.pl-12{
  padding-left: 3rem;
}
.pl-14{
  padding-left: 3.5rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-7{
  padding-left: 1.75rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-9{
  padding-left: 2.25rem;
}
.pr-0{
  padding-right: 0px;
}
.pr-0\\.5{
  padding-right: 0.125rem;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-8{
  padding-right: 2rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-14{
  padding-top: 3.5rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-2\\.5{
  padding-top: 0.625rem;
}
.pt-20{
  padding-top: 5rem;
}
.pt-28{
  padding-top: 7rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-7{
  padding-top: 1.75rem;
}
.pt-8{
  padding-top: 2rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-top{
  vertical-align: top;
}
.align-middle{
  vertical-align: middle;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-6xl{
  font-size: 3.75rem;
  line-height: 1;
}
.text-\\[0\\.84rem\\]{
  font-size: 0.84rem;
}
.text-\\[0\\.88rem\\]{
  font-size: 0.88rem;
}
.text-\\[0\\.92rem\\]{
  font-size: 0.92rem;
}
.text-\\[0\\.93rem\\]{
  font-size: 0.93rem;
}
.text-\\[0\\.96rem\\]{
  font-size: 0.96rem;
}
.text-\\[1\\.35rem\\]{
  font-size: 1.35rem;
}
.text-\\[1\\.65rem\\]{
  font-size: 1.65rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[4rem\\]{
  font-size: 4rem;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-body{
  font-size: var(--text-body);
  line-height: 1.6;
}
.text-display{
  font-size: var(--text-display);
  line-height: 1.1;
  letter-spacing: -0.04em;
  font-weight: 600;
}
.text-heading{
  font-size: var(--text-heading);
  line-height: 1.15;
  letter-spacing: -0.03em;
  font-weight: 600;
}
.text-label{
  font-size: var(--text-label);
  letter-spacing: 0.01em;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-title{
  font-size: var(--text-title);
  line-height: 1.25;
  font-weight: 600;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.capitalize{
  text-transform: capitalize;
}
.normal-case{
  text-transform: none;
}
.italic{
  font-style: italic;
}
.not-italic{
  font-style: normal;
}
.normal-nums{
  font-variant-numeric: normal;
}
.ordinal{
  --tw-ordinal: ordinal;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.slashed-zero{
  --tw-slashed-zero: slashed-zero;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.lining-nums{
  --tw-numeric-figure: lining-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.oldstyle-nums{
  --tw-numeric-figure: oldstyle-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.proportional-nums{
  --tw-numeric-spacing: proportional-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.diagonal-fractions{
  --tw-numeric-fraction: diagonal-fractions;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.stacked-fractions{
  --tw-numeric-fraction: stacked-fractions;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-5{
  line-height: 1.25rem;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-7{
  line-height: 1.75rem;
}
.leading-8{
  line-height: 2rem;
}
.leading-\\[1\\.05\\]{
  line-height: 1.05;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[-0\\.04em\\]{
  letter-spacing: -0.04em;
}
.tracking-\\[0\\.12em\\]{
  letter-spacing: 0.12em;
}
.tracking-\\[0\\.14em\\]{
  letter-spacing: 0.14em;
}
.tracking-\\[0\\.15em\\]{
  letter-spacing: 0.15em;
}
.tracking-\\[0\\.16em\\]{
  letter-spacing: 0.16em;
}
.tracking-\\[0\\.18em\\]{
  letter-spacing: 0.18em;
}
.tracking-\\[0\\.22em\\]{
  letter-spacing: 0.22em;
}
.tracking-\\[0\\.24em\\]{
  letter-spacing: 0.24em;
}
.tracking-\\[0\\.25em\\]{
  letter-spacing: 0.25em;
}
.tracking-\\[0\\.28em\\]{
  letter-spacing: 0.28em;
}
.tracking-\\[0\\.2em\\]{
  letter-spacing: 0.2em;
}
.tracking-\\[0\\.32em\\]{
  letter-spacing: 0.32em;
}
.tracking-\\[0\\.35em\\]{
  letter-spacing: 0.35em;
}
.tracking-\\[0\\.3em\\]{
  letter-spacing: 0.3em;
}
.tracking-\\[0\\.4em\\]{
  letter-spacing: 0.4em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-\\[\\#021631\\]{
  --tw-text-opacity: 1;
  color: rgb(2 22 49 / var(--tw-text-opacity, 1));
}
.text-\\[\\#081838\\]{
  --tw-text-opacity: 1;
  color: rgb(8 24 56 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0B1C4E\\]{
  --tw-text-opacity: 1;
  color: rgb(11 28 78 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0F265A\\]{
  --tw-text-opacity: 1;
  color: rgb(15 38 90 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3B5BD6\\]{
  --tw-text-opacity: 1;
  color: rgb(59 91 214 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4165ff\\]{
  --tw-text-opacity: 1;
  color: rgb(65 101 255 / var(--tw-text-opacity, 1));
}
.text-\\[color\\:\\#0F265A\\]{
  --tw-text-opacity: 1;
  color: rgb(15 38 90 / var(--tw-text-opacity, 1));
}
.text-\\[color\\:var\\(--sm-primary\\)\\]{
  color: var(--sm-primary);
}
.text-\\[color\\:var\\(--sm-text\\)\\]{
  color: var(--sm-text);
}
.text-\\[color\\:var\\(--sm-text-muted\\)\\]{
  color: var(--sm-text-muted);
}
.text-\\[color\\:var\\(--sm-text-on-panel\\)\\]{
  color: var(--sm-text-on-panel);
}
.text-\\[color\\:var\\(--sm-text-on-panel-muted\\)\\]{
  color: var(--sm-text-on-panel-muted);
}
.text-accent-foreground{
  color: hsl(var(--accent-foreground));
}
.text-amber-100{
  --tw-text-opacity: 1;
  color: rgb(254 243 199 / var(--tw-text-opacity, 1));
}
.text-amber-200{
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}
.text-amber-300{
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-amber-900{
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-blue-100{
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}
.text-blue-100\\/90{
  color: rgb(219 234 254 / 0.9);
}
.text-blue-100\\/95{
  color: rgb(219 234 254 / 0.95);
}
.text-blue-200{
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}
.text-blue-300{
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.text-blue-50{
  --tw-text-opacity: 1;
  color: rgb(239 246 255 / var(--tw-text-opacity, 1));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-blue-900{
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-card-foreground{
  color: hsl(var(--card-foreground));
}
.text-current{
  color: currentColor;
}
.text-destructive{
  color: hsl(var(--destructive));
}
.text-destructive-foreground{
  color: hsl(var(--destructive-foreground));
}
.text-emerald-200{
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}
.text-emerald-500{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-700\\/80{
  color: rgb(4 120 87 / 0.8);
}
.text-emerald-800{
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-emerald-900{
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.text-emerald-950{
  --tw-text-opacity: 1;
  color: rgb(2 44 34 / var(--tw-text-opacity, 1));
}
.text-foreground{
  color: hsl(var(--foreground));
}
.text-indigo-900{
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.text-inherit{
  color: inherit;
}
.text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.text-orange-300{
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity, 1));
}
.text-orange-500{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-popover-foreground{
  color: hsl(var(--popover-foreground));
}
.text-primary{
  color: hsl(var(--primary));
}
.text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.text-primary\\/60{
  color: hsl(var(--primary) / 0.6);
}
.text-primary\\/70{
  color: hsl(var(--primary) / 0.7);
}
.text-primary\\/80{
  color: hsl(var(--primary) / 0.8);
}
.text-red-100{
  --tw-text-opacity: 1;
  color: rgb(254 226 226 / var(--tw-text-opacity, 1));
}
.text-red-200{
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity, 1));
}
.text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-red-900{
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}
.text-rose-200{
  --tw-text-opacity: 1;
  color: rgb(254 205 211 / var(--tw-text-opacity, 1));
}
.text-rose-300{
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity, 1));
}
.text-rose-500{
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}
.text-rose-600{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-rose-700{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.text-rose-800{
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity, 1));
}
.text-rose-900{
  --tw-text-opacity: 1;
  color: rgb(136 19 55 / var(--tw-text-opacity, 1));
}
.text-rose-950{
  --tw-text-opacity: 1;
  color: rgb(76 5 25 / var(--tw-text-opacity, 1));
}
.text-secondary-foreground{
  color: hsl(var(--secondary-foreground));
}
.text-sky-700{
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity, 1));
}
.text-sky-950{
  --tw-text-opacity: 1;
  color: rgb(8 47 73 / var(--tw-text-opacity, 1));
}
.text-slate-100{
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}
.text-slate-100\\/85{
  color: rgb(241 245 249 / 0.85);
}
.text-slate-200{
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.text-slate-300{
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-50{
  --tw-text-opacity: 1;
  color: rgb(248 250 252 / var(--tw-text-opacity, 1));
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-800{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-slate-900{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-slate-950{
  --tw-text-opacity: 1;
  color: rgb(2 6 23 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/60{
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/70{
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/75{
  color: rgb(255 255 255 / 0.75);
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/85{
  color: rgb(255 255 255 / 0.85);
}
.text-white\\/90{
  color: rgb(255 255 255 / 0.9);
}
.underline{
  text-decoration-line: underline;
}
.overline{
  text-decoration-line: overline;
}
.line-through{
  text-decoration-line: line-through;
}
.no-underline{
  text-decoration-line: none;
}
.underline-offset-2{
  text-underline-offset: 2px;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.antialiased{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.subpixel-antialiased{
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
}
.caret-white{
  caret-color: #fff;
}
.accent-primary{
  accent-color: hsl(var(--primary));
}
.opacity-0{
  opacity: 0;
}
.opacity-10{
  opacity: 0.1;
}
.opacity-100{
  opacity: 1;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-90{
  opacity: 0.9;
}
.opacity-95{
  opacity: 0.95;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_18px_rgba\\(79\\2c 107\\2c 255\\2c 0\\.24\\)\\]{
  --tw-shadow: 0 10px 18px rgba(79,107,255,0.24);
  --tw-shadow-colored: 0 10px 18px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_24px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.12\\)\\]{
  --tw-shadow: 0 10px 24px rgba(15,23,42,0.12);
  --tw-shadow-colored: 0 10px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_30px_rgba\\(37\\2c 99\\2c 235\\2c 0\\.14\\)\\]{
  --tw-shadow: 0 10px 30px rgba(37,99,235,0.14);
  --tw-shadow-colored: 0 10px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_24px_rgba\\(225\\2c 29\\2c 72\\2c 0\\.28\\)\\]{
  --tw-shadow: 0 12px 24px rgba(225,29,72,0.28);
  --tw-shadow-colored: 0 12px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_24px_rgba\\(30\\2c 64\\2c 175\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 12px 24px rgba(30,64,175,0.35);
  --tw-shadow-colored: 0 12px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_30px_rgba\\(190\\2c 24\\2c 93\\2c 0\\.12\\)\\]{
  --tw-shadow: 0 12px 30px rgba(190,24,93,0.12);
  --tw-shadow-colored: 0 12px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_30px_rgba\\(37\\2c 99\\2c 235\\2c 0\\.16\\)\\]{
  --tw-shadow: 0 12px 30px rgba(37,99,235,0.16);
  --tw-shadow-colored: 0 12px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_30px_rgba\\(6\\2c 21\\2c 60\\2c 0\\.25\\)\\]{
  --tw-shadow: 0 12px 30px rgba(6,21,60,0.25);
  --tw-shadow-colored: 0 12px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_14px_30px_rgba\\(24\\2c 74\\2c 163\\2c 0\\.24\\)\\]{
  --tw-shadow: 0 14px 30px rgba(24,74,163,0.24);
  --tw-shadow-colored: 0 14px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_15px_35px_rgba\\(5\\2c 20\\2c 45\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 15px 35px rgba(5,20,45,0.35);
  --tw-shadow-colored: 0 15px 35px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_40px_rgba\\(15\\2c 38\\2c 90\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 16px 40px rgba(15,38,90,0.08);
  --tw-shadow-colored: 0 16px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_18px_35px_rgba\\(18\\2c 46\\2c 99\\2c 0\\.28\\)\\]{
  --tw-shadow: 0 18px 35px rgba(18,46,99,0.28);
  --tw-shadow-colored: 0 18px 35px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_18px_40px_-20px_rgba\\(30\\2c 58\\2c 138\\2c 0\\.6\\)\\]{
  --tw-shadow: 0 18px 40px -20px rgba(30,58,138,0.6);
  --tw-shadow-colored: 0 18px 40px -20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_18px_40px_rgba\\(15\\2c 38\\2c 90\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 18px 40px rgba(15,38,90,0.35);
  --tw-shadow-colored: 0 18px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_18px_45px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 18px 45px rgba(15,23,42,0.08);
  --tw-shadow-colored: 0 18px 45px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_18px_46px_rgba\\(15\\2c 38\\2c 90\\2c 0\\.11\\)\\]{
  --tw-shadow: 0 18px 46px rgba(15,38,90,0.11);
  --tw-shadow-colored: 0 18px 46px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_18px_48px_rgba\\(15\\2c 38\\2c 90\\2c 0\\.18\\)\\]{
  --tw-shadow: 0 18px 48px rgba(15,38,90,0.18);
  --tw-shadow-colored: 0 18px 48px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_50px_-40px_rgba\\(30\\2c 64\\2c 175\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 20px 50px -40px rgba(30,64,175,0.35);
  --tw-shadow-colored: 0 20px 50px -40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_50px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 20px 50px rgba(15,23,42,0.08);
  --tw-shadow-colored: 0 20px 50px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_50px_rgba\\(3\\2c 7\\2c 18\\2c 0\\.38\\)\\]{
  --tw-shadow: 0 20px 50px rgba(3,7,18,0.38);
  --tw-shadow-colored: 0 20px 50px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_60px_-45px_rgba\\(24\\2c 60\\2c 165\\2c 0\\.25\\)\\]{
  --tw-shadow: 0 20px 60px -45px rgba(24,60,165,0.25);
  --tw-shadow-colored: 0 20px 60px -45px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_60px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 20px 60px rgba(15,23,42,0.08);
  --tw-shadow-colored: 0 20px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_60px_rgba\\(3\\2c 8\\2c 20\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 20px 60px rgba(3,8,20,0.35);
  --tw-shadow-colored: 0 20px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_60px_-45px_rgba\\(30\\2c 64\\2c 175\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 24px 60px -45px rgba(30,64,175,0.35);
  --tw-shadow-colored: 0 24px 60px -45px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_70px_rgba\\(15\\2c 38\\2c 90\\2c 0\\.16\\)\\]{
  --tw-shadow: 0 24px 70px rgba(15,38,90,0.16);
  --tw-shadow-colored: 0 24px 70px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_80px_rgba\\(8\\2c 26\\2c 70\\2c 0\\.22\\)\\]{
  --tw-shadow: 0 24px 80px rgba(8,26,70,0.22);
  --tw-shadow-colored: 0 24px 80px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_80px_rgba\\(8\\2c 26\\2c 70\\2c 0\\.24\\)\\]{
  --tw-shadow: 0 24px 80px rgba(8,26,70,0.24);
  --tw-shadow-colored: 0 24px 80px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_25px_120px_rgba\\(4\\2c 15\\2c 42\\2c 0\\.45\\)\\]{
  --tw-shadow: 0 25px 120px rgba(4,15,42,0.45);
  --tw-shadow-colored: 0 25px 120px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_25px_60px_-40px_rgba\\(15\\2c 23\\2c 42\\2c 1\\)\\]{
  --tw-shadow: 0 25px 60px -40px rgba(15,23,42,1);
  --tw-shadow-colored: 0 25px 60px -40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_25px_80px_rgba\\(15\\2c 38\\2c 90\\2c 0\\.12\\)\\]{
  --tw-shadow: 0 25px 80px rgba(15,38,90,0.12);
  --tw-shadow-colored: 0 25px 80px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_25px_90px_rgba\\(15\\2c 38\\2c 90\\2c 0\\.15\\)\\]{
  --tw-shadow: 0 25px 90px rgba(15,38,90,0.15);
  --tw-shadow-colored: 0 25px 90px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_28px_80px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.2\\)\\]{
  --tw-shadow: 0 28px 80px rgba(15,23,42,0.2);
  --tw-shadow-colored: 0 28px 80px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_28px_80px_rgba\\(8\\2c 26\\2c 70\\2c 0\\.26\\)\\]{
  --tw-shadow: 0 28px 80px rgba(8,26,70,0.26);
  --tw-shadow-colored: 0 28px 80px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_30px_80px_-60px_rgba\\(30\\2c 64\\2c 175\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 30px 80px -60px rgba(30,64,175,0.35);
  --tw-shadow-colored: 0 30px 80px -60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_30px_90px_rgba\\(15\\2c 38\\2c 90\\2c 0\\.25\\)\\]{
  --tw-shadow: 0 30px 90px rgba(15,38,90,0.25);
  --tw-shadow-colored: 0 30px 90px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_30px_90px_rgba\\(6\\2c 21\\2c 60\\2c 0\\.45\\)\\]{
  --tw-shadow: 0 30px 90px rgba(6,21,60,0.45);
  --tw-shadow-colored: 0 30px 90px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_32px_95px_rgba\\(8\\2c 26\\2c 70\\2c 0\\.28\\)\\]{
  --tw-shadow: 0 32px 95px rgba(8,26,70,0.28);
  --tw-shadow-colored: 0 32px 95px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_35px_110px_rgba\\(8\\2c 26\\2c 70\\2c 0\\.28\\)\\]{
  --tw-shadow: 0 35px 110px rgba(8,26,70,0.28);
  --tw-shadow-colored: 0 35px 110px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_35px_120px_rgba\\(2\\2c 8\\2c 20\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 35px 120px rgba(2,8,20,0.35);
  --tw-shadow-colored: 0 35px 120px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_35px_120px_rgba\\(9\\2c 20\\2c 51\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 35px 120px rgba(9,20,51,0.35);
  --tw-shadow-colored: 0 35px 120px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_45px_140px_rgba\\(4\\2c 15\\2c 42\\2c 0\\.55\\)\\]{
  --tw-shadow: 0 45px 140px rgba(4,15,42,0.55);
  --tw-shadow-colored: 0 45px 140px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_6px_14px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.2\\)\\]{
  --tw-shadow: 0 6px 14px rgba(15,23,42,0.2);
  --tw-shadow-colored: 0 6px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_6px_14px_rgba\\(95\\2c 120\\2c 220\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 6px 14px rgba(95,120,220,0.08);
  --tw-shadow-colored: 0 6px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[12px_0_36px_rgba\\(9\\2c 20\\2c 51\\2c 0\\.28\\)\\]{
  --tw-shadow: 12px 0 36px rgba(9,20,51,0.28);
  --tw-shadow-colored: 12px 0 36px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_1px_0_rgba\\(255\\2c 255\\2c 255\\2c 0\\.25\\)\\2c 0_12px_22px_rgba\\(42\\2c 74\\2c 182\\2c 0\\.22\\)\\]{
  --tw-shadow: inset 0 1px 0 rgba(255,255,255,0.25),0 12px 22px rgba(42,74,182,0.22);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color), 0 12px 22px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_1px_0_rgba\\(255\\2c 255\\2c 255\\2c 0\\.65\\)\\2c 0_18px_40px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.08\\)\\]{
  --tw-shadow: inset 0 1px 0 rgba(255,255,255,0.65),0 18px 40px rgba(15,23,42,0.08);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color), 0 18px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_1px_0_rgba\\(255\\2c 255\\2c 255\\2c 0\\.95\\)\\2c 0_8px_18px_rgba\\(141\\2c 161\\2c 218\\2c 0\\.08\\)\\]{
  --tw-shadow: inset 0 1px 0 rgba(255,255,255,0.95),0 8px 18px rgba(141,161,218,0.08);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color), 0 8px 18px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner{
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-blue-100{
  --tw-shadow-color: #dbeafe;
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset{
  --tw-ring-inset: inset;
}
.ring-blue-400{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity, 1));
}
.ring-blue-400\\/35{
  --tw-ring-color: rgb(96 165 250 / 0.35);
}
.ring-blue-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.ring-primary{
  --tw-ring-color: hsl(var(--primary));
}
.ring-primary\\/20{
  --tw-ring-color: hsl(var(--primary) / 0.2);
}
.ring-slate-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(203 213 225 / var(--tw-ring-opacity, 1));
}
.ring-slate-900{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(15 23 42 / var(--tw-ring-opacity, 1));
}
.ring-slate-900\\/70{
  --tw-ring-color: rgb(15 23 42 / 0.7);
}
.ring-white{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.ring-offset-2{
  --tw-ring-offset-width: 2px;
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background));
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[140px\\]{
  --tw-blur: blur(140px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[160px\\]{
  --tw-blur: blur(160px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[200px\\]{
  --tw-blur: blur(200px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-lg{
  --tw-blur: blur(16px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_18px_40px_rgba\\(2\\2c 8\\2c 20\\2c 0\\.45\\)\\]{
  --tw-drop-shadow: drop-shadow(0 18px 40px rgba(2,8,20,0.45));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_18px_50px_rgba\\(3\\2c 8\\2c 20\\2c 0\\.4\\)\\]{
  --tw-drop-shadow: drop-shadow(0 18px 50px rgba(3,8,20,0.4));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_18px_50px_rgba\\(3\\2c 8\\2c 20\\2c 0\\.45\\)\\]{
  --tw-drop-shadow: drop-shadow(0 18px 50px rgba(3,8,20,0.45));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_8px_24px_rgba\\(63\\2c 125\\2c 201\\2c 0\\.35\\)\\]{
  --tw-drop-shadow: drop-shadow(0 8px 24px rgba(63,125,201,0.35));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale{
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert{
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.sepia{
  --tw-sepia: sepia(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-2xl{
  --tw-backdrop-blur: blur(40px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[2px\\]{
  --tw-backdrop-blur: blur(2px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-grayscale{
  --tw-backdrop-grayscale: grayscale(100%);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-invert{
  --tw-backdrop-invert: invert(100%);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-sepia{
  --tw-backdrop-sepia: sepia(100%);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter{
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.\\!transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\]{
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
@keyframes enter{

  from{
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit{

  to{
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in{
  --tw-enter-opacity: 0;
}
.fade-in-0{
  --tw-enter-opacity: 0;
}
.zoom-in{
  --tw-enter-scale: 0;
}
.zoom-in-95{
  --tw-enter-scale: .95;
}
.zoom-out{
  --tw-exit-scale: 0;
}
.slide-in-from-bottom{
  --tw-enter-translate-y: 100%;
}
.slide-in-from-left-1{
  --tw-enter-translate-x: -0.25rem;
}
.slide-in-from-top{
  --tw-enter-translate-y: -100%;
}
.slide-out-to-left-1{
  --tw-exit-translate-x: -0.25rem;
}
.duration-200{
  animation-duration: 200ms;
}
.duration-300{
  animation-duration: 300ms;
}
.duration-500{
  animation-duration: 500ms;
}
.ease-in-out{
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.running{
  animation-play-state: running;
}
.paused{
  animation-play-state: paused;
}
.\\[background-image\\:radial-gradient\\(circle\\2c _rgba\\(148\\2c 170\\2c 220\\2c 0\\.35\\)_1px\\2c _transparent_1px\\)\\]{
  background-image: radial-gradient(circle, rgba(148,170,220,0.35) 1px, transparent 1px);
}
.\\[background-image\\:radial-gradient\\(circle\\2c _rgba\\(148\\2c 170\\2c 220\\2c 0\\.45\\)_1px\\2c _transparent_1px\\)\\]{
  background-image: radial-gradient(circle, rgba(148,170,220,0.45) 1px, transparent 1px);
}
.\\[background-image\\:radial-gradient\\(circle_at_1px_1px\\2c rgba\\(148\\2c 163\\2c 184\\2c 0\\.2\\)_1px\\2c transparent_0\\)\\]{
  background-image: radial-gradient(circle at 1px 1px,rgba(148,163,184,0.2) 1px,transparent 0);
}
.\\[background-size\\:18px_18px\\]{
  background-size: 18px 18px;
}
.\\[background-size\\:22px_22px\\]{
  background-size: 22px 22px;
}
.file\\:border-0::file-selector-button{
  border-width: 0px;
}
.file\\:bg-transparent::file-selector-button{
  background-color: transparent;
}
.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:font-medium::file-selector-button{
  font-weight: 500;
}
.file\\:text-foreground::file-selector-button{
  color: hsl(var(--foreground));
}
.placeholder\\:text-\\[color\\:var\\(--sm-text-muted\\)\\]::-moz-placeholder{
  color: var(--sm-text-muted);
}
.placeholder\\:text-\\[color\\:var\\(--sm-text-muted\\)\\]::placeholder{
  color: var(--sm-text-muted);
}
.placeholder\\:text-muted-foreground::-moz-placeholder{
  color: hsl(var(--muted-foreground));
}
.placeholder\\:text-muted-foreground::placeholder{
  color: hsl(var(--muted-foreground));
}
.placeholder\\:text-slate-400::-moz-placeholder{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-slate-400::placeholder{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-white\\/60::-moz-placeholder{
  color: rgb(255 255 255 / 0.6);
}
.placeholder\\:text-white\\/60::placeholder{
  color: rgb(255 255 255 / 0.6);
}
.focus-within\\:ring-2:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-blue-500\\/30:focus-within{
  --tw-ring-color: rgb(59 130 246 / 0.3);
}
.hover\\:-translate-y-0\\.5:hover{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.01\\]:hover{
  --tw-scale-x: 1.01;
  --tw-scale-y: 1.01;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-primary\\/20:hover{
  border-color: hsl(var(--primary) / 0.2);
}
.hover\\:border-primary\\/25:hover{
  border-color: hsl(var(--primary) / 0.25);
}
.hover\\:border-primary\\/30:hover{
  border-color: hsl(var(--primary) / 0.3);
}
.hover\\:border-primary\\/40:hover{
  border-color: hsl(var(--primary) / 0.4);
}
.hover\\:border-primary\\/50:hover{
  border-color: hsl(var(--primary) / 0.5);
}
.hover\\:border-primary\\/60:hover{
  border-color: hsl(var(--primary) / 0.6);
}
.hover\\:border-slate-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.hover\\:bg-\\[\\#132f75\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(19 47 117 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#132f7a\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(19 47 122 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[color\\:var\\(--sm-surface-muted\\)\\]:hover{
  background-color: var(--sm-surface-muted);
}
.hover\\:bg-accent:hover{
  background-color: hsl(var(--accent));
}
.hover\\:bg-amber-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-destructive\\/80:hover{
  background-color: hsl(var(--destructive) / 0.8);
}
.hover\\:bg-destructive\\/90:hover{
  background-color: hsl(var(--destructive) / 0.9);
}
.hover\\:bg-emerald-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-fuchsia-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(217 70 239 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-muted:hover{
  background-color: hsl(var(--muted));
}
.hover\\:bg-muted\\/50:hover{
  background-color: hsl(var(--muted) / 0.5);
}
.hover\\:bg-orange-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-orange-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-primary\\/10:hover{
  background-color: hsl(var(--primary) / 0.1);
}
.hover\\:bg-primary\\/5:hover{
  background-color: hsl(var(--primary) / 0.05);
}
.hover\\:bg-primary\\/80:hover{
  background-color: hsl(var(--primary) / 0.8);
}
.hover\\:bg-primary\\/90:hover{
  background-color: hsl(var(--primary) / 0.9);
}
.hover\\:bg-red-100\\/40:hover{
  background-color: rgb(254 226 226 / 0.4);
}
.hover\\:bg-rose-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-secondary\\/80:hover{
  background-color: hsl(var(--secondary) / 0.8);
}
.hover\\:bg-slate-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-950:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(2 6 23 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/15:hover{
  background-color: rgb(255 255 255 / 0.15);
}
.hover\\:bg-white\\/90:hover{
  background-color: rgb(255 255 255 / 0.9);
}
.hover\\:bg-\\[linear-gradient\\(90deg\\2c \\#1f378e\\2c \\#2f56ca_46\\%\\2c \\#63a2ff\\)\\]:hover{
  background-image: linear-gradient(90deg,#1f378e,#2f56ca 46%,#63a2ff);
}
.hover\\:from-\\[\\#0d285c\\]:hover{
  --tw-gradient-from: #0d285c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(13 40 92 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:to-\\[\\#1f4da8\\]:hover{
  --tw-gradient-to: #1f4da8 var(--tw-gradient-to-position);
}
.hover\\:text-\\[color\\:var\\(--sm-text\\)\\]:hover{
  color: var(--sm-text);
}
.hover\\:text-accent-foreground:hover{
  color: hsl(var(--accent-foreground));
}
.hover\\:text-foreground:hover{
  color: hsl(var(--foreground));
}
.hover\\:text-muted-foreground:hover{
  color: hsl(var(--muted-foreground));
}
.hover\\:text-primary:hover{
  color: hsl(var(--primary));
}
.hover\\:text-rose-600:hover{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-700:hover{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-900:hover{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-950:hover{
  --tw-text-opacity: 1;
  color: rgb(2 6 23 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover{
  text-decoration-line: underline;
}
.hover\\:opacity-100:hover{
  opacity: 1;
}
.hover\\:opacity-90:hover{
  opacity: 0.9;
}
.hover\\:opacity-95:hover{
  opacity: 0.95;
}
.hover\\:shadow-\\[0_10px_24px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.12\\)\\]:hover{
  --tw-shadow: 0 10px 24px rgba(15,23,42,0.12);
  --tw-shadow-colored: 0 10px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_12px_26px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.12\\)\\]:hover{
  --tw-shadow: 0 12px 26px rgba(15,23,42,0.12);
  --tw-shadow-colored: 0 12px 26px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_20px_40px_rgba\\(15\\2c 38\\2c 90\\2c 0\\.12\\)\\]:hover{
  --tw-shadow: 0 20px 40px rgba(15,38,90,0.12);
  --tw-shadow-colored: 0 20px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[inset_0_1px_0_rgba\\(255\\2c 255\\2c 255\\2c 0\\.75\\)\\2c 0_24px_48px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.12\\)\\]:hover{
  --tw-shadow: inset 0 1px 0 rgba(255,255,255,0.75),0 24px 48px rgba(15,23,42,0.12);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color), 0 24px 48px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:brightness-105:hover{
  --tw-brightness: brightness(1.05);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hover\\:brightness-110:hover{
  --tw-brightness: brightness(1.1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.focus\\:bg-accent:focus{
  background-color: hsl(var(--accent));
}
.focus\\:bg-rose-50:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.focus\\:text-accent-foreground:focus{
  color: hsl(var(--accent-foreground));
}
.focus\\:text-rose-700:focus{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-ring:focus{
  --tw-ring-color: hsl(var(--ring));
}
.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:border-\\[color\\:var\\(--sm-primary\\)\\]:focus-visible{
  border-color: var(--sm-primary);
}
.focus-visible\\:border-blue-400:focus-visible{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.focus-visible\\:opacity-100:focus-visible{
  opacity: 1;
}
.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-0:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-inset:focus-visible{
  --tw-ring-inset: inset;
}
.focus-visible\\:ring-\\[color\\:var\\(--sm-focus\\)\\]:focus-visible{
  --tw-ring-color: var(--sm-focus);
}
.focus-visible\\:ring-blue-500:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-blue-500\\/30:focus-visible{
  --tw-ring-color: rgb(59 130 246 / 0.3);
}
.focus-visible\\:ring-blue-500\\/50:focus-visible{
  --tw-ring-color: rgb(59 130 246 / 0.5);
}
.focus-visible\\:ring-destructive:focus-visible{
  --tw-ring-color: hsl(var(--destructive));
}
.focus-visible\\:ring-primary\\/50:focus-visible{
  --tw-ring-color: hsl(var(--primary) / 0.5);
}
.focus-visible\\:ring-ring:focus-visible{
  --tw-ring-color: hsl(var(--ring));
}
.focus-visible\\:ring-white:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-white\\/40:focus-visible{
  --tw-ring-color: rgb(255 255 255 / 0.4);
}
.focus-visible\\:ring-offset-0:focus-visible{
  --tw-ring-offset-width: 0px;
}
.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-background:focus-visible{
  --tw-ring-offset-color: hsl(var(--background));
}
.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:cursor-wait:disabled{
  cursor: wait;
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.group:hover .group-hover\\:scale-\\[1\\.01\\]{
  --tw-scale-x: 1.01;
  --tw-scale-y: 1.01;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:border-primary\\/40{
  border-color: hsl(var(--primary) / 0.4);
}
.group:hover .group-hover\\:text-\\[color\\:var\\(--sm-text\\)\\]{
  color: var(--sm-text);
}
.group:hover .group-hover\\:text-slate-900{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
  cursor: not-allowed;
}
.peer:disabled ~ .peer-disabled\\:opacity-70{
  opacity: 0.7;
}
.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"]{
  pointer-events: none;
}
.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
  pointer-events: none;
}
.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=checked\\]\\:translate-x-5[data-state="checked"]{
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=checked\\]\\:border-blue-300[data-state="checked"]{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.data-\\[state\\=checked\\]\\:border-blue-600[data-state="checked"]{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.data-\\[state\\=checked\\]\\:border-blue-700[data-state="checked"]{
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / var(--tw-border-opacity, 1));
}
.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=active\\]\\:bg-background[data-state="active"]{
  background-color: hsl(var(--background));
}
.data-\\[state\\=checked\\]\\:bg-blue-600[data-state="checked"]{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=checked\\]\\:bg-blue-700[data-state="checked"]{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]{
  background-color: hsl(var(--primary));
}
.data-\\[state\\=on\\]\\:bg-accent[data-state="on"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent[data-state="open"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"]{
  background-color: hsl(var(--accent) / 0.5);
}
.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"]{
  background-color: hsl(var(--secondary));
}
.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"]{
  background-color: hsl(var(--muted));
}
.data-\\[state\\=unchecked\\]\\:bg-slate-200[data-state="unchecked"]{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder]{
  color: hsl(var(--muted-foreground));
}
.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=active\\]\\:text-foreground[data-state="active"]{
  color: hsl(var(--foreground));
}
.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"]{
  color: hsl(var(--primary-foreground));
}
.data-\\[state\\=checked\\]\\:text-white[data-state="checked"]{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"]{
  color: hsl(var(--muted-foreground));
}
.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"]{
  opacity: 0.5;
}
.data-\\[disabled\\]\\:opacity-50[data-disabled]{
  opacity: 0.5;
}
.data-\\[state\\=active\\]\\:shadow-sm[data-state="active"]{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[state\\=checked\\]\\:shadow-\\[0_0_0_2px_rgba\\(37\\2c 99\\2c 235\\2c 0\\.28\\)\\][data-state="checked"]{
  --tw-shadow: 0 0 0 2px rgba(37,99,235,0.28);
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  transition-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  transition-duration: 500ms;
}
.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"]{
  --tw-enter-opacity: 0;
}
.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
  --tw-exit-scale: .95;
}
.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"]{
  --tw-enter-scale: .9;
}
.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
  --tw-enter-scale: .95;
}
.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"]{
  --tw-enter-translate-x: 13rem;
}
.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"]{
  --tw-enter-translate-x: -13rem;
}
.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"]{
  --tw-exit-translate-x: 13rem;
}
.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"]{
  --tw-exit-translate-x: -13rem;
}
.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
  --tw-enter-translate-y: -0.5rem;
}
.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
  --tw-enter-translate-x: 0.5rem;
}
.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
  --tw-enter-translate-x: -0.5rem;
}
.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
  --tw-enter-translate-y: 0.5rem;
}
.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"]{
  --tw-exit-translate-y: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"]{
  --tw-exit-translate-x: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"]{
  --tw-exit-translate-x: -50%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"]{
  --tw-exit-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"]{
  --tw-exit-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"]{
  --tw-enter-translate-y: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"]{
  --tw-enter-translate-x: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"]{
  --tw-enter-translate-x: -50%;
}
.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"]{
  --tw-enter-translate-x: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"]{
  --tw-enter-translate-y: -48%;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  animation-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  animation-duration: 500ms;
}
.data-\\[state\\=open\\]\\:hover\\:bg-accent:hover[data-state="open"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:focus\\:bg-accent:focus[data-state="open"]{
  background-color: hsl(var(--accent));
}
.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.dark\\:divide-slate-700\\/40:is(.dark *) > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(51 65 85 / 0.4);
}
.dark\\:border-\\[color\\:var\\(--sm-border-on-panel\\)\\]:is(.dark *){
  border-color: var(--sm-border-on-panel);
}
.dark\\:border-amber-500\\/30:is(.dark *){
  border-color: rgb(245 158 11 / 0.3);
}
.dark\\:border-amber-900\\/40:is(.dark *){
  border-color: rgb(120 53 15 / 0.4);
}
.dark\\:border-blue-400\\/70:is(.dark *){
  border-color: rgb(96 165 250 / 0.7);
}
.dark\\:border-blue-400\\/80:is(.dark *){
  border-color: rgb(96 165 250 / 0.8);
}
.dark\\:border-blue-500\\/30:is(.dark *){
  border-color: rgb(59 130 246 / 0.3);
}
.dark\\:border-destructive:is(.dark *){
  border-color: hsl(var(--destructive));
}
.dark\\:border-emerald-400\\/20:is(.dark *){
  border-color: rgb(52 211 153 / 0.2);
}
.dark\\:border-emerald-500\\/30:is(.dark *){
  border-color: rgb(16 185 129 / 0.3);
}
.dark\\:border-fuchsia-900\\/40:is(.dark *){
  border-color: rgb(112 26 117 / 0.4);
}
.dark\\:border-orange-900\\/40:is(.dark *){
  border-color: rgb(124 45 18 / 0.4);
}
.dark\\:border-primary\\/30:is(.dark *){
  border-color: hsl(var(--primary) / 0.3);
}
.dark\\:border-primary\\/50:is(.dark *){
  border-color: hsl(var(--primary) / 0.5);
}
.dark\\:border-red-500\\/30:is(.dark *){
  border-color: rgb(239 68 68 / 0.3);
}
.dark\\:border-rose-600\\/40:is(.dark *){
  border-color: rgb(225 29 72 / 0.4);
}
.dark\\:border-rose-900\\/40:is(.dark *){
  border-color: rgb(136 19 55 / 0.4);
}
.dark\\:border-slate-600:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
}
.dark\\:border-slate-700:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
}
.dark\\:border-slate-700\\/40:is(.dark *){
  border-color: rgb(51 65 85 / 0.4);
}
.dark\\:border-slate-700\\/45:is(.dark *){
  border-color: rgb(51 65 85 / 0.45);
}
.dark\\:border-slate-700\\/50:is(.dark *){
  border-color: rgb(51 65 85 / 0.5);
}
.dark\\:border-slate-700\\/60:is(.dark *){
  border-color: rgb(51 65 85 / 0.6);
}
.dark\\:border-slate-700\\/70:is(.dark *){
  border-color: rgb(51 65 85 / 0.7);
}
.dark\\:border-slate-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity, 1));
}
.dark\\:border-transparent:is(.dark *){
  border-color: transparent;
}
.dark\\:border-white\\/70:is(.dark *){
  border-color: rgb(255 255 255 / 0.7);
}
.dark\\:bg-\\[\\#0F172A\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#121C2E\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(18 28 46 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-amber-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-amber-500\\/10:is(.dark *){
  background-color: rgb(245 158 11 / 0.1);
}
.dark\\:bg-amber-500\\/15:is(.dark *){
  background-color: rgb(245 158 11 / 0.15);
}
.dark\\:bg-amber-950\\/20:is(.dark *){
  background-color: rgb(69 26 3 / 0.2);
}
.dark\\:bg-blue-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-blue-500\\/10:is(.dark *){
  background-color: rgb(59 130 246 / 0.1);
}
.dark\\:bg-blue-500\\/15:is(.dark *){
  background-color: rgb(59 130 246 / 0.15);
}
.dark\\:bg-blue-500\\/20:is(.dark *){
  background-color: rgb(59 130 246 / 0.2);
}
.dark\\:bg-blue-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-emerald-500\\/10:is(.dark *){
  background-color: rgb(16 185 129 / 0.1);
}
.dark\\:bg-emerald-500\\/15:is(.dark *){
  background-color: rgb(16 185 129 / 0.15);
}
.dark\\:bg-emerald-500\\/20:is(.dark *){
  background-color: rgb(16 185 129 / 0.2);
}
.dark\\:bg-fuchsia-500:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(217 70 239 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-fuchsia-950\\/20:is(.dark *){
  background-color: rgb(74 4 78 / 0.2);
}
.dark\\:bg-orange-500:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-orange-950\\/20:is(.dark *){
  background-color: rgb(67 20 7 / 0.2);
}
.dark\\:bg-primary\\/10:is(.dark *){
  background-color: hsl(var(--primary) / 0.1);
}
.dark\\:bg-primary\\/15:is(.dark *){
  background-color: hsl(var(--primary) / 0.15);
}
.dark\\:bg-red-500\\/10:is(.dark *){
  background-color: rgb(239 68 68 / 0.1);
}
.dark\\:bg-red-500\\/15:is(.dark *){
  background-color: rgb(239 68 68 / 0.15);
}
.dark\\:bg-rose-500:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-rose-500\\/20:is(.dark *){
  background-color: rgb(244 63 94 / 0.2);
}
.dark\\:bg-rose-950\\/20:is(.dark *){
  background-color: rgb(76 5 25 / 0.2);
}
.dark\\:bg-slate-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-slate-700\\/70:is(.dark *){
  background-color: rgb(51 65 85 / 0.7);
}
.dark\\:bg-slate-800:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-slate-800\\/80:is(.dark *){
  background-color: rgb(30 41 59 / 0.8);
}
.dark\\:bg-slate-800\\/90:is(.dark *){
  background-color: rgb(30 41 59 / 0.9);
}
.dark\\:bg-slate-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-slate-900\\/60:is(.dark *){
  background-color: rgb(15 23 42 / 0.6);
}
.dark\\:bg-slate-900\\/70:is(.dark *){
  background-color: rgb(15 23 42 / 0.7);
}
.dark\\:bg-slate-900\\/80:is(.dark *){
  background-color: rgb(15 23 42 / 0.8);
}
.dark\\:bg-slate-900\\/85:is(.dark *){
  background-color: rgb(15 23 42 / 0.85);
}
.dark\\:bg-slate-900\\/90:is(.dark *){
  background-color: rgb(15 23 42 / 0.9);
}
.dark\\:bg-slate-900\\/95:is(.dark *){
  background-color: rgb(15 23 42 / 0.95);
}
.dark\\:bg-slate-950:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(2 6 23 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-slate-950\\/20:is(.dark *){
  background-color: rgb(2 6 23 / 0.2);
}
.dark\\:bg-slate-950\\/40:is(.dark *){
  background-color: rgb(2 6 23 / 0.4);
}
.dark\\:bg-slate-950\\/60:is(.dark *){
  background-color: rgb(2 6 23 / 0.6);
}
.dark\\:bg-slate-950\\/90:is(.dark *){
  background-color: rgb(2 6 23 / 0.9);
}
.dark\\:bg-slate-950\\/95:is(.dark *){
  background-color: rgb(2 6 23 / 0.95);
}
.dark\\:bg-white:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-white\\/10:is(.dark *){
  background-color: rgb(255 255 255 / 0.1);
}
.dark\\:bg-\\[linear-gradient\\(180deg\\2c rgba\\(15\\2c 23\\2c 42\\2c 0\\.985\\)\\2c rgba\\(17\\2c 27\\2c 47\\2c 0\\.97\\)\\)\\]:is(.dark *){
  background-image: linear-gradient(180deg,rgba(15,23,42,0.985),rgba(17,27,47,0.97));
}
.dark\\:bg-\\[linear-gradient\\(180deg\\2c rgba\\(20\\2c 30\\2c 49\\2c 1\\)\\2c rgba\\(17\\2c 27\\2c 47\\2c 0\\.98\\)\\)\\]:is(.dark *){
  background-image: linear-gradient(180deg,rgba(20,30,49,1),rgba(17,27,47,0.98));
}
.dark\\:bg-\\[radial-gradient\\(circle\\2c _rgba\\(0\\2c 0\\2c 0\\2c 0\\.42\\)\\2c _transparent_62\\%\\)\\]:is(.dark *){
  background-image: radial-gradient(circle, rgba(0,0,0,0.42), transparent 62%);
}
.dark\\:bg-\\[radial-gradient\\(circle\\2c _rgba\\(59\\2c 130\\2c 246\\2c 0\\.18\\)\\2c _transparent_62\\%\\)\\]:is(.dark *){
  background-image: radial-gradient(circle, rgba(59,130,246,0.18), transparent 62%);
}
.dark\\:bg-\\[radial-gradient\\(circle_at_20\\%_20\\%\\2c _rgba\\(76\\2c 120\\2c 255\\2c 0\\.12\\)\\2c _transparent_50\\%\\)\\]:is(.dark *){
  background-image: radial-gradient(circle at 20% 20%, rgba(76,120,255,0.12), transparent 50%);
}
.dark\\:bg-\\[radial-gradient\\(circle_at_80\\%_30\\%\\2c _rgba\\(76\\2c 120\\2c 255\\2c 0\\.08\\)\\2c _transparent_50\\%\\)\\]:is(.dark *){
  background-image: radial-gradient(circle at 80% 30%, rgba(76,120,255,0.08), transparent 50%);
}
.dark\\:bg-\\[radial-gradient\\(circle_at_top\\2c _\\#0b1222\\2c _\\#0b1222_45\\%\\2c _\\#05070f_100\\%\\)\\]:is(.dark *){
  background-image: radial-gradient(circle at top, #0b1222, #0b1222 45%, #05070f 100%);
}
.dark\\:bg-gradient-to-br:is(.dark *){
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.dark\\:from-\\[\\#081126\\]:is(.dark *){
  --tw-gradient-from: #081126 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(8 17 38 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:from-\\[\\#0B1F4D\\]:is(.dark *){
  --tw-gradient-from: #0B1F4D var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(11 31 77 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:from-\\[\\#111B2F\\]:is(.dark *){
  --tw-gradient-from: #111B2F var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(17 27 47 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:from-slate-900\\/70:is(.dark *){
  --tw-gradient-from: rgb(15 23 42 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:from-slate-950\\/90:is(.dark *){
  --tw-gradient-from: rgb(2 6 23 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(2 6 23 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:via-\\[\\#0A1A3F\\]:is(.dark *){
  --tw-gradient-to: rgb(10 26 63 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0A1A3F var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.dark\\:via-\\[\\#0F172A\\]:is(.dark *){
  --tw-gradient-to: rgb(15 23 42 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0F172A var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.dark\\:via-\\[\\#0b1f4d\\]:is(.dark *){
  --tw-gradient-to: rgb(11 31 77 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0b1f4d var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.dark\\:via-slate-900\\/90:is(.dark *){
  --tw-gradient-to: rgb(15 23 42 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(15 23 42 / 0.9) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.dark\\:to-\\[\\#07112D\\]:is(.dark *){
  --tw-gradient-to: #07112D var(--tw-gradient-to-position);
}
.dark\\:to-\\[\\#0B1220\\]:is(.dark *){
  --tw-gradient-to: #0B1220 var(--tw-gradient-to-position);
}
.dark\\:to-\\[\\#163a7a\\]:is(.dark *){
  --tw-gradient-to: #163a7a var(--tw-gradient-to-position);
}
.dark\\:to-slate-900\\/40:is(.dark *){
  --tw-gradient-to: rgb(15 23 42 / 0.4) var(--tw-gradient-to-position);
}
.dark\\:to-slate-900\\/80:is(.dark *){
  --tw-gradient-to: rgb(15 23 42 / 0.8) var(--tw-gradient-to-position);
}
.dark\\:text-\\[color\\:var\\(--sm-text-on-panel\\)\\]:is(.dark *){
  color: var(--sm-text-on-panel);
}
.dark\\:text-amber-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(254 243 199 / var(--tw-text-opacity, 1));
}
.dark\\:text-amber-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}
.dark\\:text-amber-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.dark\\:text-blue-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}
.dark\\:text-blue-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.dark\\:text-emerald-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}
.dark\\:text-emerald-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.dark\\:text-inherit:is(.dark *){
  color: inherit;
}
.dark\\:text-red-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity, 1));
}
.dark\\:text-rose-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(254 205 211 / var(--tw-text-opacity, 1));
}
.dark\\:text-rose-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-100\\/85:is(.dark *){
  color: rgb(241 245 249 / 0.85);
}
.dark\\:text-slate-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-50:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(248 250 252 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-950:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(2 6 23 / var(--tw-text-opacity, 1));
}
.dark\\:text-white:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.dark\\:opacity-15:is(.dark *){
  opacity: 0.15;
}
.dark\\:opacity-30:is(.dark *){
  opacity: 0.3;
}
.dark\\:shadow-\\[0_25px_80px_rgba\\(2\\2c 6\\2c 23\\2c 0\\.55\\)\\]:is(.dark *){
  --tw-shadow: 0 25px 80px rgba(2,6,23,0.55);
  --tw-shadow-colored: 0 25px 80px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.dark\\:shadow-\\[inset_0_1px_0_rgba\\(255\\2c 255\\2c 255\\2c 0\\.03\\)\\2c 0_10px_20px_rgba\\(2\\2c 8\\2c 23\\2c 0\\.24\\)\\]:is(.dark *){
  --tw-shadow: inset 0 1px 0 rgba(255,255,255,0.03),0 10px 20px rgba(2,8,23,0.24);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color), 0 10px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.dark\\:shadow-none:is(.dark *){
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.dark\\:ring-blue-400\\/35:is(.dark *){
  --tw-ring-color: rgb(96 165 250 / 0.35);
}
.dark\\:placeholder\\:text-slate-400:is(.dark *)::-moz-placeholder{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.dark\\:placeholder\\:text-slate-400:is(.dark *)::placeholder{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:border-blue-400\\/40:hover:is(.dark *){
  border-color: rgb(96 165 250 / 0.4);
}
.dark\\:hover\\:border-blue-400\\/45:hover:is(.dark *){
  border-color: rgb(96 165 250 / 0.45);
}
.dark\\:hover\\:border-primary\\/40:hover:is(.dark *){
  border-color: hsl(var(--primary) / 0.4);
}
.dark\\:hover\\:bg-amber-400:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-fuchsia-500:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(217 70 239 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-orange-500:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-rose-500:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-slate-700:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-slate-700\\/80:hover:is(.dark *){
  background-color: rgb(51 65 85 / 0.8);
}
.dark\\:hover\\:bg-slate-800:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-slate-800\\/80:hover:is(.dark *){
  background-color: rgb(30 41 59 / 0.8);
}
.dark\\:hover\\:bg-slate-900:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:text-white:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.dark\\:focus\\:bg-rose-500\\/10:focus:is(.dark *){
  background-color: rgb(244 63 94 / 0.1);
}
.group:hover .dark\\:group-hover\\:text-white:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.dark\\:data-\\[state\\=checked\\]\\:border-blue-400[data-state="checked"]:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.dark\\:data-\\[state\\=checked\\]\\:bg-blue-500[data-state="checked"]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.dark\\:data-\\[state\\=unchecked\\]\\:bg-slate-800[data-state="unchecked"]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.dark\\:data-\\[state\\=checked\\]\\:shadow-\\[0_0_0_2px_rgba\\(96\\2c 165\\2c 250\\2c 0\\.35\\)\\][data-state="checked"]:is(.dark *){
  --tw-shadow: 0 0 0 2px rgba(96,165,250,0.35);
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
@media (min-width: 640px){

  .sm\\:order-1{
    order: 1;
  }

  .sm\\:order-2{
    order: 2;
  }

  .sm\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .sm\\:mx-7{
    margin-left: 1.75rem;
    margin-right: 1.75rem;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:hidden{
    display: none;
  }

  .sm\\:h-11{
    height: 2.75rem;
  }

  .sm\\:h-12{
    height: 3rem;
  }

  .sm\\:h-14{
    height: 3.5rem;
  }

  .sm\\:h-24{
    height: 6rem;
  }

  .sm\\:h-7{
    height: 1.75rem;
  }

  .sm\\:w-14{
    width: 3.5rem;
  }

  .sm\\:w-24{
    width: 6rem;
  }

  .sm\\:w-7{
    width: 1.75rem;
  }

  .sm\\:w-\\[220px\\]{
    width: 220px;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:min-w-\\[220px\\]{
    min-width: 220px;
  }

  .sm\\:max-w-\\[24ch\\]{
    max-width: 24ch;
  }

  .sm\\:max-w-\\[260px\\]{
    max-width: 260px;
  }

  .sm\\:max-w-\\[400px\\]{
    max-width: 400px;
  }

  .sm\\:max-w-\\[460px\\]{
    max-width: 460px;
  }

  .sm\\:max-w-\\[480px\\]{
    max-width: 480px;
  }

  .sm\\:max-w-\\[520px\\]{
    max-width: 520px;
  }

  .sm\\:max-w-\\[760px\\]{
    max-width: 760px;
  }

  .sm\\:max-w-\\[820px\\]{
    max-width: 820px;
  }

  .sm\\:max-w-\\[92\\%\\]{
    max-width: 92%;
  }

  .sm\\:max-w-sm{
    max-width: 24rem;
  }

  .sm\\:max-w-xl{
    max-width: 36rem;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .sm\\:items-end{
    align-items: flex-end;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:justify-between{
    justify-content: space-between;
  }

  .sm\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
  }

  .sm\\:rounded-\\[32px\\]{
    border-radius: 32px;
  }

  .sm\\:rounded-lg{
    border-radius: var(--radius);
  }

  .sm\\:p-5{
    padding: 1.25rem;
  }

  .sm\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-7{
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .sm\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .sm\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .sm\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .sm\\:pb-4{
    padding-bottom: 1rem;
  }

  .sm\\:pb-8{
    padding-bottom: 2rem;
  }

  .sm\\:pl-12{
    padding-left: 3rem;
  }

  .sm\\:pt-10{
    padding-top: 2.5rem;
  }

  .sm\\:pt-8{
    padding-top: 2rem;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:text-\\[0\\.92rem\\]{
    font-size: 0.92rem;
  }

  .sm\\:text-\\[0\\.95rem\\]{
    font-size: 0.95rem;
  }

  .sm\\:text-\\[1\\.95rem\\]{
    font-size: 1.95rem;
  }

  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:opacity-0{
    opacity: 0;
  }

  .group:hover .sm\\:group-hover\\:opacity-100{
    opacity: 1;
  }
}
@media (min-width: 768px){

  .md\\:absolute{
    position: absolute;
  }

  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .md\\:block{
    display: block;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:w-64{
    width: 16rem;
  }

  .md\\:w-\\[320px\\]{
    width: 320px;
  }

  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\]{
    width: var(--radix-navigation-menu-viewport-width);
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:min-w-\\[280px\\]{
    min-width: 280px;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:justify-end{
    justify-content: flex-end;
  }

  .md\\:justify-between{
    justify-content: space-between;
  }

  .md\\:gap-0{
    gap: 0px;
  }

  .md\\:gap-4{
    gap: 1rem;
  }

  .md\\:p-6{
    padding: 1.5rem;
  }

  .md\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .md\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 1024px){

  .lg\\:absolute{
    position: absolute;
  }

  .lg\\:sticky{
    position: sticky;
  }

  .lg\\:inset-x-0{
    left: 0px;
    right: 0px;
  }

  .lg\\:top-0{
    top: 0px;
  }

  .lg\\:top-8{
    top: 2rem;
  }

  .lg\\:ml-\\[260px\\]{
    margin-left: 260px;
  }

  .lg\\:ml-auto{
    margin-left: auto;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:grid{
    display: grid;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:h-12{
    height: 3rem;
  }

  .lg\\:h-\\[calc\\(100vh-104px\\)\\]{
    height: calc(100vh - 104px);
  }

  .lg\\:h-\\[min\\(94vh\\2c 1120px\\)\\]{
    height: min(94vh,1120px);
  }

  .lg\\:h-full{
    height: 100%;
  }

  .lg\\:max-h-full{
    max-height: 100%;
  }

  .lg\\:min-h-\\[760px\\]{
    min-height: 760px;
  }

  .lg\\:min-h-screen{
    min-height: 100vh;
  }

  .lg\\:w-12{
    width: 3rem;
  }

  .lg\\:w-36{
    width: 9rem;
  }

  .lg\\:w-40{
    width: 10rem;
  }

  .lg\\:w-44{
    width: 11rem;
  }

  .lg\\:w-auto{
    width: auto;
  }

  .lg\\:max-w-7xl{
    max-width: 80rem;
  }

  .lg\\:max-w-\\[380px\\]{
    max-width: 380px;
  }

  .lg\\:max-w-\\[420px\\]{
    max-width: 420px;
  }

  .lg\\:max-w-\\[470px\\]{
    max-width: 470px;
  }

  .lg\\:max-w-\\[560px\\]{
    max-width: 560px;
  }

  .lg\\:max-w-\\[700px\\]{
    max-width: 700px;
  }

  .lg\\:max-w-xl{
    max-width: 36rem;
  }

  .lg\\:translate-x-0{
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[1\\.05fr_0\\.95fr\\]{
    grid-template-columns: 1.05fr 0.95fr;
  }

  .lg\\:grid-cols-\\[1\\.15fr_1fr\\]{
    grid-template-columns: 1.15fr 1fr;
  }

  .lg\\:grid-cols-\\[1\\.1fr_0\\.9fr\\]{
    grid-template-columns: 1.1fr 0.9fr;
  }

  .lg\\:grid-cols-\\[1\\.1fr_1\\.4fr\\]{
    grid-template-columns: 1.1fr 1.4fr;
  }

  .lg\\:grid-cols-\\[220px_260px_auto\\]{
    grid-template-columns: 220px 260px auto;
  }

  .lg\\:grid-cols-\\[2fr\\2c 1fr\\]{
    grid-template-columns: 2fr 1fr;
  }

  .lg\\:grid-cols-\\[2fr_1fr_1fr_1fr_1fr_140px\\]{
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr 140px;
  }

  .lg\\:grid-cols-\\[320px_1fr\\]{
    grid-template-columns: 320px 1fr;
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 1\\.1fr\\)_minmax\\(0\\2c 0\\.9fr\\)\\]{
    grid-template-columns: minmax(0,1.1fr) minmax(0,0.9fr);
  }

  .lg\\:grid-cols-\\[minmax\\(360px\\2c 0\\.95fr\\)_minmax\\(560px\\2c 1\\.15fr\\)\\]{
    grid-template-columns: minmax(360px,0.95fr) minmax(560px,1.15fr);
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:items-start{
    align-items: flex-start;
  }

  .lg\\:items-center{
    align-items: center;
  }

  .lg\\:items-stretch{
    align-items: stretch;
  }

  .lg\\:justify-end{
    justify-content: flex-end;
  }

  .lg\\:justify-between{
    justify-content: space-between;
  }

  .lg\\:gap-8{
    gap: 2rem;
  }

  .lg\\:self-start{
    align-self: flex-start;
  }

  .lg\\:justify-self-center{
    justify-self: center;
  }

  .lg\\:rounded-none{
    border-radius: 0px;
  }

  .lg\\:border-l{
    border-left-width: 1px;
  }

  .lg\\:border-white\\/50{
    border-color: rgb(255 255 255 / 0.5);
  }

  .lg\\:bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }

  .lg\\:p-8{
    padding: 2rem;
  }

  .lg\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .lg\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .lg\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:px-9{
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .lg\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .lg\\:pb-0{
    padding-bottom: 0px;
  }

  .lg\\:pb-16{
    padding-bottom: 4rem;
  }

  .lg\\:pb-7{
    padding-bottom: 1.75rem;
  }

  .lg\\:pt-28{
    padding-top: 7rem;
  }

  .lg\\:pt-7{
    padding-top: 1.75rem;
  }

  .lg\\:pt-8{
    padding-top: 2rem;
  }

  .lg\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .lg\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }

  .lg\\:text-\\[2rem\\]{
    font-size: 2rem;
  }

  .lg\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .lg\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 1280px){

  .xl\\:shrink-0{
    flex-shrink: 0;
  }

  .xl\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-\\[1\\.4fr_1fr\\]{
    grid-template-columns: 1.4fr 1fr;
  }

  .xl\\:grid-cols-\\[2\\.2fr_1fr\\]{
    grid-template-columns: 2.2fr 1fr;
  }

  .xl\\:flex-row{
    flex-direction: row;
  }

  .xl\\:items-center{
    align-items: center;
  }

  .xl\\:justify-between{
    justify-content: space-between;
  }

  .xl\\:gap-6{
    gap: 1.5rem;
  }

  .xl\\:text-\\[4\\.5rem\\]{
    font-size: 4.5rem;
  }
}
.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]){
  padding-right: 0px;
}
.\\[\\&\\>span\\]\\:line-clamp-1>span{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div{
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>svg\\]\\:absolute>svg{
  position: absolute;
}
.\\[\\&\\>svg\\]\\:left-4>svg{
  left: 1rem;
}
.\\[\\&\\>svg\\]\\:top-4>svg{
  top: 1rem;
}
.\\[\\&\\>svg\\]\\:h-3\\.5>svg{
  height: 0.875rem;
}
.\\[\\&\\>svg\\]\\:w-3\\.5>svg{
  width: 0.875rem;
}
.\\[\\&\\>svg\\]\\:text-destructive>svg{
  color: hsl(var(--destructive));
}
.\\[\\&\\>svg\\]\\:text-foreground>svg{
  color: hsl(var(--foreground));
}
.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~*{
  padding-left: 1.75rem;
}
.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr{
  border-bottom-width: 0px;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading]{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading]{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading]{
  font-weight: 500;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading]{
  color: hsl(var(--muted-foreground));
}
.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group]{
  padding-top: 0px;
}
.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-group\\]\\]\\:py-2 [cmdk-group]{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg{
  width: 1.25rem;
}
.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input]{
  height: 3rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item]{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg{
  width: 1.25rem;
}
.\\[\\&_p\\]\\:leading-relaxed p{
  line-height: 1.625;
}
.\\[\\&_svg\\]\\:pointer-events-none svg{
  pointer-events: none;
}
.\\[\\&_svg\\]\\:size-4 svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&_svg\\]\\:shrink-0 svg{
  flex-shrink: 0;
}
.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child{
  border-width: 0px;
}
.\\[\\&_tr\\]\\:border-b tr{
  border-bottom-width: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,iJAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,iBAAc;EAAd,6BAAc;EAAd,6BAAc;EAAd,mCAAc;EAAd;AAAc;;AAAd;IAAA,uBAAc;IAAd,4BAAc;IAAd,oCAAc;IAAd,0BAAc;IAAd,sBAAc;IAAd,kCAAc;IAAd,4BAAc;IAAd,6BAAc;IAAd,0BAAc;IAAd,uBAAc;IAAd,+BAAc;IAAd;;qGAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,kBAAc;IAAd,wBAAc;IAAd,2BAAc;IAAd,iCAAc;IAAd,mCAAc;IAAd,+CAAc;IAAd,qBAAc;IAAd,oBAAc;IAAd,mCAAc;EAAA;;AAAd;IAAA,uBAAc;IAAd,4BAAc;IAAd,oCAAc;IAAd,0BAAc;IAAd,sBAAc;IAAd,kCAAc;IAAd,4BAAc;IAAd,6BAAc;IAAd,0BAAc;IAAd,uBAAc;IAAd,+BAAc;IAAd,gFAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,kBAAc;IAAd,wBAAc;IAAd,2BAAc;IAAd,iCAAc;IAAd,sCAAc;IAAd,8CAAc;IAAd,qBAAc;IAAd,oBAAc;IAAd,oCAAc;EAAA;AACd;EAAA,sBAAoB;EAApB,6BAAoB;EAApB,4BAAoB;EAApB,gCAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AA+EhB;EAAA,iBAAsE;EAAtE,mCAAsE;EAAtE;AAAsE;AAItE;EAAA,iBAA4E;EAA5E,kBAA4E;EAA5E,WAA4E;EAA5E,gBAA4E;EAA5E,kBAA4E;EAA5E,mBAA4E;EAA5E,oBAA4E;EAA5E;AAA4E;AAA5E;;EAAA;IAAA,oBAA4E;IAA5E;EAA4E;AAAA;AAA5E;;EAAA;IAAA,gBAA4E;IAA5E,kBAA4E;IAA5E;EAA4E;AAAA;AAI5E;EAAA,mBAA8J;EAA9J,iBAA8J;EAA9J,8BAA8J;EAA9J,mCAA8J;EAA9J,qBAA8J;EAA9J,4CAA8J;EAA9J,uDAA8J;EAA9J;AAA8J;AAI9J;EAAA,mBAA2H;EAA3H,iBAA2H;EAA3H,8BAA2H;EAA3H,yCAA2H;EAA3H;AAA2H;AAI3H;EAAA,mBAA4K;EAA5K,iBAA4K;EAA5K,uCAA4K;EAA5K,iCAA4K;EAA5K,8BAA4K;EAA5K,0CAA4K;EAA5K,uDAA4K;EAA5K;AAA4K;AAI5K;EAAA,mBAAuI;EAAvI,iBAAuI;EAAvI,uCAAuI;EAAvI,mCAAuI;EAAvI;AAAuI;AAIvI;EAAA,aAA0B;EAA1B,sBAA0B;EAA1B;AAA0B;AAI1B;EAAA,kBAA0F;EAA1F,iBAA0F;EAA1F,gBAA0F;EAA1F,yBAA0F;EAA1F,sBAA0F;EAA1F;AAA0F;AAI1F;EAAA,iBAAyD;EAAzD,iBAAyD;EAAzD,gBAAyD;EAAzD;AAAyD;AAIzD;EAAA,mBAAgD;EAAhD,oBAAgD;EAAhD;AAAgD;AAIhD;EAAA,oBAAwV;EAAxV,mBAAwV;EAAxV,uBAAwV;EAAxV,qBAAwV;EAAxV,mCAAwV;EAAxV,qBAAwV;EAAxV,sBAAwV;EAAxV,mBAAwV;EAAxV,sBAAwV;EAAxV,mBAAwV;EAAxV,oBAAwV;EAAxV,gBAAwV;EAAxV,oBAAwV;EAAxV,mDAAwV;EAAxV,6CAAwV;EAAxV,uDAAwV;EAAxV,uGAAwV;EAAxV,wJAAwV;EAAxV,wDAAwV;EAAxV;AAAwV;AAAxV;EAAA,gCAAwV;EAAxV;AAAwV;AAAxV;EAAA,8BAAwV;EAAxV,mBAAwV;EAAxV,2GAAwV;EAAxV,yGAAwV;EAAxV,4FAAwV;EAAxV;AAAwV;AAAxV;EAAA,mBAAwV;EAAxV;AAAwV;AAIxV;EAAA,oBAA4W;EAA5W,mBAA4W;EAA5W,uBAA4W;EAA5W,qBAA4W;EAA5W,iBAA4W;EAA5W,8BAA4W;EAA5W,yCAA4W;EAA5W,qBAA4W;EAA5W,sBAA4W;EAA5W,mBAA4W;EAA5W,sBAA4W;EAA5W,mBAA4W;EAA5W,oBAA4W;EAA5W,gBAA4W;EAA5W,qBAA4W;EAA5W,wJAA4W;EAA5W,wDAA4W;EAA5W;AAA4W;AAA5W;EAAA,iCAA4W;EAA5W;AAA4W;AAA5W;EAAA,8BAA4W;EAA5W,mBAA4W;EAA5W,2GAA4W;EAA5W,yGAA4W;EAA5W,4FAA4W;EAA5W;AAA4W;AAA5W;EAAA,mBAA4W;EAA5W;AAA4W;AAI5W;EAAA,oBAAwX;EAAxX,mBAAwX;EAAxX,uBAAwX;EAAxX,qBAAwX;EAAxX,iBAAwX;EAAxX,uCAAwX;EAAxX,mCAAwX;EAAxX,qBAAwX;EAAxX,sBAAwX;EAAxX,mBAAwX;EAAxX,sBAAwX;EAAxX,mBAAwX;EAAxX,oBAAwX;EAAxX,gBAAwX;EAAxX,8BAAwX;EAAxX,wJAAwX;EAAxX,wDAAwX;EAAxX;AAAwX;AAAxX;EAAA,gCAAwX;EAAxX;AAAwX;AAAxX;EAAA,8BAAwX;EAAxX,mBAAwX;EAAxX,2GAAwX;EAAxX,yGAAwX;EAAxX,4FAAwX;EAAxX;AAAwX;AAAxX;EAAA,mBAAwX;EAAxX;AAAwX;AAIxX;EAAA,oBAA8S;EAA9S,mBAA8S;EAA9S,uBAA8S;EAA9S,qBAA8S;EAA9S,kBAA8S;EAA9S,mBAA8S;EAA9S,mBAA8S;EAA9S,sBAA8S;EAA9S,mBAA8S;EAA9S,oBAA8S;EAA9S,gBAA8S;EAA9S,2BAA8S;EAA9S,wJAA8S;EAA9S,wDAA8S;EAA9S;AAA8S;AAA9S;EAAA,yCAA8S;EAA9S;AAA8S;AAA9S;EAAA,8BAA8S;EAA9S,mBAA8S;EAA9S,2GAA8S;EAA9S,yGAA8S;EAA9S,4FAA8S;EAA9S;AAA8S;AAI9S;EAAA,oBAAuV;EAAvV,mBAAuV;EAAvV,uBAAuV;EAAvV,qBAAuV;EAAvV,kCAAuV;EAAvV,qBAAuV;EAAvV,sBAAuV;EAAvV,mBAAuV;EAAvV,sBAAuV;EAAvV,mBAAuV;EAAvV,oBAAuV;EAAvV,gBAAuV;EAAvV,oBAAuV;EAAvV,mDAAuV;EAAvV,6CAAuV;EAAvV,uDAAuV;EAAvV,uGAAuV;EAAvV,wJAAuV;EAAvV,wDAAuV;EAAvV;AAAuV;AAAvV;EAAA,gCAAuV;EAAvV;AAAuV;AAAvV;EAAA,8BAAuV;EAAvV,mBAAuV;EAAvV,2GAAuV;EAAvV,yGAAuV;EAAvV,4FAAuV;EAAvV;AAAuV;AAAvV;EAAA,mBAAuV;EAAvV;AAAuV;AAIvV;EAAA,eAA4U;EAA5U,mBAA4U;EAA5U,iBAA4U;EAA5U,8BAA4U;EAA5U,mCAA4U;EAA5U,kBAA4U;EAA5U,mBAA4U;EAA5U,mBAA4U;EAA5U,oBAA4U;EAA5U,qBAA4U;EAA5U,gDAA4U;EAA5U,6DAA4U;EAA5U;AAA4U;AAA5U;EAAA;AAA4U;AAA5U;EAAA;AAA4U;AAA5U;EAAA,+BAA4U;EAA5U,8BAA4U;EAA5U,mBAA4U;EAA5U,2GAA4U;EAA5U,yGAA4U;EAA5U,4FAA4U;EAA5U;AAA4U;AAI5U;EAAA,iBAA0V;EAA1V,mBAA0V;EAA1V,iBAA0V;EAA1V,8BAA0V;EAA1V,mCAA0V;EAA1V,kBAA0V;EAA1V,mBAA0V;EAA1V,oBAA0V;EAA1V,uBAA0V;EAA1V,mBAA0V;EAA1V,oBAA0V;EAA1V,qBAA0V;EAA1V,gDAA0V;EAA1V,6DAA0V;EAA1V;AAA0V;AAA1V;EAAA;AAA0V;AAA1V;EAAA;AAA0V;AAA1V;EAAA,+BAA0V;EAA1V,8BAA0V;EAA1V,mBAA0V;EAA1V,2GAA0V;EAA1V,yGAA0V;EAA1V,4FAA0V;EAA1V;AAA0V;AAI1V;EAAA,eAAiR;EAAjR,mBAAiR;EAAjR,iBAAiR;EAAjR,8BAAiR;EAAjR,mCAAiR;EAAjR,kBAAiR;EAAjR,mBAAiR;EAAjR,mBAAiR;EAAjR,oBAAiR;EAAjR;AAAiR;AAAjR;EAAA,+BAAiR;EAAjR,8BAAiR;EAAjR,mBAAiR;EAAjR,2GAAiR;EAAjR,yGAAiR;EAAjR,4FAAiR;EAAjR;AAAiR;AAIjR;EAAA,oBAAwL;EAAxL,mBAAwL;EAAxL,WAAwL;EAAxL,qBAAwL;EAAxL,iBAAwL;EAAxL,8BAAwL;EAAxL,yCAAwL;EAAxL,qBAAwL;EAAxL,sBAAwL;EAAxL,oBAAwL;EAAxL,uBAAwL;EAAxL,kBAAwL;EAAxL,iBAAwL;EAAxL,gBAAwL;EAAxL;AAAwL;AAIxL;EAAA,aAAyO;EAAzO,mBAAyO;EAAzO,8BAAyO;EAAzO,YAAyO;EAAzO,mBAAyO;EAAzO,iBAAyO;EAAzO,8BAAyO;EAAzO,mCAAyO;EAAzO,kBAAyO;EAAzO,mBAAyO;EAAzO,oBAAyO;EAAzO,uBAAyO;EAAzO,mBAAyO;EAAzO,oBAAyO;EAAzO,qBAAyO;EAAzO,wJAAyO;EAAzO,wDAAyO;EAAzO;AAAyO;AAAzO;EAAA,4CAAyO;EAAzO,uDAAyO;EAAzO;AAAyO;AAIzO;EAAA,aAAuN;EAAvN,sBAAuN;EAAvN,mBAAuN;EAAvN,uBAAuN;EAAvN,WAAuN;EAAvN,mBAAuN;EAAvN,iBAAuN;EAAvN,oBAAuN;EAAvN,8BAAuN;EAAvN,yCAAuN;EAAvN,eAAuN;EAAvN,kBAAuN;EAAvN,mBAAuN;EAAvN,oBAAuN;EAAvN;AAAuN;AAIvN;EAAA,mBAAiK;EAAjK,iBAAiK;EAAjK,8BAAiK;EAAjK,mCAAiK;EAAjK,eAAiK;EAAjK,qBAAiK;EAAjK,2CAAiK;EAAjK,uDAAiK;EAAjK;AAAiK;AAlKrK;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,WAAmB;EAAnB,YAAmB;EAAnB,UAAmB;EAAnB,SAAmB;EAAnB,iBAAmB;EAAnB,UAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;KAAnB,sBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,8EAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;KAAnB;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,iBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kFAAmB;EAAnB,6FAAmB;EAAnB;AAAmB;AAAnB;EAAA,iFAAmB;EAAnB,6FAAmB;EAAnB;AAAmB;AAAnB;EAAA,mFAAmB;EAAnB,4FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mKAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAJnB;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,mBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,2GAyKA;EAzKA,yGAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,2BAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,4DAyKA;EAzKA,kEAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,4CAyKA;EAzKA,uDAyKA;EAzKA;AAyKA;AAzKA;EAAA,4CAyKA;EAzKA,uDAyKA;EAzKA;AAyKA;AAzKA;EAAA,4CAyKA;EAzKA,uDAyKA;EAzKA;AAyKA;AAzKA;EAAA,iFAyKA;EAzKA,6FAyKA;EAzKA;AAyKA;AAzKA;EAAA,+EAyKA;EAzKA,mGAyKA;EAzKA;AAyKA;AAzKA;EAAA,6EAyKA;EAzKA,iGAyKA;EAzKA;AAyKA;AAzKA;EAAA,iCAyKA;EAzKA;AAyKA;AAzKA;EAAA,gCAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,8BAyKA;EAzKA;AAyKA;AAzKA;EAAA,2GAyKA;EAzKA,yGAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,8BAyKA;EAzKA;AAyKA;AAzKA;EAAA,2GAyKA;EAzKA,yGAyKA;EAzKA;AAyKA;AAzKA;EAAA,2GAyKA;EAzKA,yGAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,yBAyKA;EAzKA;AAyKA;AAzKA;EAAA,0BAyKA;EAzKA;AAyKA;AAzKA;EAAA,yBAyKA;EAzKA;AAyKA;AAzKA;EAAA,0BAyKA;EAzKA;AAyKA;AAzKA;EAAA,yBAyKA;EAzKA;AAyKA;AAzKA;EAAA,qBAyKA;EAzKA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,0CAyKA;EAzKA,uDAyKA;EAzKA;AAyKA;AAzKA;EAAA,2CAyKA;EAzKA,qDAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,qBAyKA;EAzKA,yBAyKA;EAzKA,2BAyKA;EAzKA,yBAyKA;EAzKA,0BAyKA;EAzKA,+BAyKA;EAzKA;AAyKA;AAzKA;EAAA,qBAyKA;EAzKA,yBAyKA;EAzKA,2BAyKA;EAzKA,yBAyKA;EAzKA,0BAyKA;EAzKA,+BAyKA;EAzKA;AAyKA;AAzKA;EAAA,qBAyKA;EAzKA,yBAyKA;EAzKA,2BAyKA;EAzKA,yBAyKA;EAzKA,0BAyKA;EAzKA,+BAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA,yBAyKA;EAzKA,0BAyKA;EAzKA,wBAyKA;EAzKA,yBAyKA;EAzKA,8BAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA,yBAyKA;EAzKA,0BAyKA;EAzKA,wBAyKA;EAzKA,yBAyKA;EAzKA,8BAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA,yBAyKA;EAzKA,0BAyKA;EAzKA,wBAyKA;EAzKA,yBAyKA;EAzKA,8BAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,mBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,4DAyKA;EAzKA,iEAyKA;EAzKA;AAyKA;AAzKA;EAAA,4DAyKA;EAzKA,kEAyKA;EAzKA;AAyKA;AAzKA;EAAA,4DAyKA;EAzKA,kEAyKA;EAzKA;AAyKA;AAzKA;EAAA,wEAyKA;EAzKA,kEAyKA;EAzKA;AAyKA;AAzKA;EAAA,sEAyKA;EAzKA,gEAyKA;EAzKA;AAyKA;AAzKA;EAAA,mEAyKA;EAzKA;AAyKA;AAzKA;EAAA,mEAyKA;EAzKA;AAyKA;AAzKA;EAAA,mEAyKA;EAzKA;AAyKA;AAzKA;EAAA,mEAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,0CAyKA;EAzKA,uDAyKA;EAzKA;AAyKA;AAzKA;EAAA,+EAyKA;EAzKA,6FAyKA;EAzKA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA,8BAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA,4CAyKA;EAzKA,qDAyKA;EAzKA;AAyKA;AAzKA;;EAAA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,oBAyKA;IAzKA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,uBAyKA;IAzKA,sDAyKA;IAzKA;EAyKA;;EAzKA;IAAA,uBAyKA;IAzKA,4DAyKA;IAzKA;EAyKA;;EAzKA;IAAA,uBAyKA;IAzKA,+DAyKA;IAzKA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,oBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,oBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,qBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,kBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,mBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,oBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,mBAyKA;IAzKA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,mBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,eAyKA;IAzKA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,eAyKA;IAzKA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;AAAA;AAzKA;;EAAA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,oBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,iBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,iBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,eAyKA;IAzKA;EAyKA;;EAzKA;IAAA,eAyKA;IAzKA;EAyKA;;EAzKA;IAAA,mBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,mBAyKA;IAzKA;EAyKA;AAAA;AAzKA;;EAAA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,SAyKA;IAzKA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,qBAyKA;IAzKA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,kBAyKA;IAzKA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,iBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,oBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,kBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,kBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,qBAyKA;IAzKA;EAyKA;;EAzKA;IAAA,iBAyKA;IAzKA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,eAyKA;IAzKA;EAyKA;;EAzKA;IAAA,kBAyKA;IAzKA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA,eAyKA;IAzKA;EAyKA;;EAzKA;IAAA,mBAyKA;IAzKA;EAyKA;AAAA;AAzKA;;EAAA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;;EAzKA;IAAA;EAyKA;AAAA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,gBAyKA;EAzKA,oBAyKA;EAzKA,4BAyKA;EAzKA;AAyKA;AAzKA;EAAA,sBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,qBAyKA;EAzKA;AAyKA;AAzKA;EAAA,kBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,mBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA,oBAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA,WAyKA;EAzKA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA;AAzKA;EAAA;AAyKA","sourcesContent":["@import '../../../libs/ui/src/lib/theme.css';\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  * {\n    @apply border-border;\n  }\n\n  html {\n    @apply min-h-screen;\n  }\n\n  body {\n    @apply min-h-screen bg-transparent text-foreground antialiased;\n  }\n}\n\n@layer base {\n  :root {\n    --bg: var(--sm-bg-page);\n    --surface: var(--sm-surface);\n    --surface-2: var(--sm-surface-muted);\n    --border: var(--sm-border);\n    --text: var(--sm-text);\n    --text-muted: var(--sm-text-muted);\n    --primary: var(--sm-primary);\n    --primary-foreground: #ffffff;\n    --danger: var(--sm-danger);\n    --ring: var(--sm-focus);\n    --muted-foreground: 220 18% 40%;\n    --sm-bg-page: linear-gradient(180deg, #f8fbff 0%, #eef4ff 55%, #f8fbff 100%),\n      radial-gradient(1200px circle at 25% -10%, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0) 60%),\n      radial-gradient(900px circle at 75% 110%, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0) 60%);\n    --sm-surface: #ffffff;\n    --sm-surface-muted: #f2f5fb;\n    --sm-panel: #0b1220;\n    --sm-panel-2: #111a2b;\n    --sm-text: #0b1220;\n    --sm-text-muted: #5b6b85;\n    --sm-text-on-panel: #f8fafc;\n    --sm-text-on-panel-muted: #c5d0e5;\n    --sm-border: rgba(15, 23, 42, 0.08);\n    --sm-border-on-panel: rgba(148, 163, 184, 0.28);\n    --sm-primary: #1d4ed8;\n    --sm-danger: #e11d48;\n    --sm-focus: rgba(59, 130, 246, 0.5);\n  }\n\n  .dark {\n    --bg: var(--sm-bg-page);\n    --surface: var(--sm-surface);\n    --surface-2: var(--sm-surface-muted);\n    --border: var(--sm-border);\n    --text: var(--sm-text);\n    --text-muted: var(--sm-text-muted);\n    --primary: var(--sm-primary);\n    --primary-foreground: #ffffff;\n    --danger: var(--sm-danger);\n    --ring: var(--sm-focus);\n    --muted-foreground: 214 20% 74%;\n    --sm-bg-page: radial-gradient(circle at top, #0b1222, #0b1222 45%, #060914 100%);\n    --sm-surface: #0f172a;\n    --sm-surface-muted: #111b2f;\n    --sm-panel: #0b111e;\n    --sm-panel-2: #0f182a;\n    --sm-text: #f8fafc;\n    --sm-text-muted: #c0cadb;\n    --sm-text-on-panel: #f8fafc;\n    --sm-text-on-panel-muted: #c0cadb;\n    --sm-border: rgba(148, 163, 184, 0.25);\n    --sm-border-on-panel: rgba(148, 163, 184, 0.3);\n    --sm-primary: #3b82f6;\n    --sm-danger: #fb7185;\n    --sm-focus: rgba(96, 165, 250, 0.55);\n  }\n}\n\n@layer components {\n  .sm-page {\n    @apply min-h-screen bg-[var(--sm-bg-page)] text-[color:var(--sm-text)];\n  }\n\n  .sm-container {\n    @apply mx-auto w-full max-w-6xl px-4 pb-16 pt-6 sm:px-6 lg:max-w-7xl lg:px-8;\n  }\n\n  .sm-surface-card {\n    @apply rounded-[20px] border border-[color:var(--sm-border)] bg-[color:var(--sm-surface)] text-[color:var(--sm-text)] shadow-[0_18px_45px_rgba(15,23,42,0.08)];\n  }\n\n  .sm-surface-muted {\n    @apply rounded-[18px] border border-[color:var(--sm-border)] bg-[color:var(--sm-surface-muted)] text-[color:var(--sm-text)];\n  }\n\n  .sm-panel-card {\n    @apply rounded-[20px] border border-[color:var(--sm-border-on-panel)] bg-[color:var(--sm-panel)] text-[color:var(--sm-text-on-panel)] shadow-[0_20px_50px_rgba(3,7,18,0.38)];\n  }\n\n  .sm-panel-card-muted {\n    @apply rounded-[18px] border border-[color:var(--sm-border-on-panel)] bg-[color:var(--sm-panel-2)] text-[color:var(--sm-text-on-panel)];\n  }\n\n  .sm-section-header {\n    @apply flex flex-col gap-2;\n  }\n\n  .sm-section-eyebrow {\n    @apply text-xs font-semibold uppercase tracking-[0.32em] text-[color:var(--sm-text-muted)];\n  }\n\n  .sm-section-title {\n    @apply text-2xl font-semibold text-[color:var(--sm-text)];\n  }\n\n  .sm-section-subtitle {\n    @apply text-sm text-[color:var(--sm-text-muted)];\n  }\n\n  .sm-btn-primary {\n    @apply inline-flex items-center justify-center rounded-full bg-[color:var(--sm-primary)] px-5 py-2 text-sm font-semibold text-white shadow-[0_12px_24px_rgba(30,64,175,0.35)] transition hover:brightness-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--sm-focus)] disabled:cursor-not-allowed disabled:opacity-60;\n  }\n\n  .sm-btn-secondary {\n    @apply inline-flex items-center justify-center rounded-full border border-[color:var(--sm-border)] bg-[color:var(--sm-surface-muted)] px-5 py-2 text-sm font-semibold text-[color:var(--sm-text)] transition hover:brightness-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--sm-focus)] disabled:cursor-not-allowed disabled:opacity-60;\n  }\n\n  .sm-btn-secondary-panel {\n    @apply inline-flex items-center justify-center rounded-full border border-[color:var(--sm-border-on-panel)] bg-[color:var(--sm-panel-2)] px-5 py-2 text-sm font-semibold text-[color:var(--sm-text-on-panel)] transition hover:brightness-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--sm-focus)] disabled:cursor-not-allowed disabled:opacity-60;\n  }\n\n  .sm-btn-ghost {\n    @apply inline-flex items-center justify-center rounded-full px-4 py-2 text-sm font-semibold text-[color:var(--sm-text-muted)] transition hover:bg-[color:var(--sm-surface-muted)] hover:text-[color:var(--sm-text)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--sm-focus)];\n  }\n\n  .sm-btn-danger {\n    @apply inline-flex items-center justify-center rounded-full bg-[color:var(--sm-danger)] px-5 py-2 text-sm font-semibold text-white shadow-[0_12px_24px_rgba(225,29,72,0.28)] transition hover:brightness-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--sm-focus)] disabled:cursor-not-allowed disabled:opacity-60;\n  }\n\n  .sm-input {\n    @apply h-11 rounded-[14px] border border-[color:var(--sm-border)] bg-[color:var(--sm-surface)] px-4 text-sm text-[color:var(--sm-text)] shadow-inner placeholder:text-[color:var(--sm-text-muted)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--sm-focus)] focus-visible:border-[color:var(--sm-primary)];\n  }\n\n  .sm-textarea {\n    @apply min-h-[120px] rounded-[16px] border border-[color:var(--sm-border)] bg-[color:var(--sm-surface)] px-4 py-3 text-sm text-[color:var(--sm-text)] shadow-inner placeholder:text-[color:var(--sm-text-muted)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--sm-focus)] focus-visible:border-[color:var(--sm-primary)];\n  }\n\n  .sm-select {\n    @apply h-11 rounded-[14px] border border-[color:var(--sm-border)] bg-[color:var(--sm-surface)] px-4 text-sm text-[color:var(--sm-text)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--sm-focus)] focus-visible:border-[color:var(--sm-primary)];\n  }\n\n  .sm-pill {\n    @apply inline-flex items-center gap-2 rounded-full border border-[color:var(--sm-border)] bg-[color:var(--sm-surface-muted)] px-3 py-1 text-xs font-semibold text-[color:var(--sm-text)];\n  }\n\n  .sm-row {\n    @apply flex items-center justify-between gap-3 rounded-[18px] border border-[color:var(--sm-border)] bg-[color:var(--sm-surface)] px-4 py-3 text-sm text-[color:var(--sm-text)] transition hover:shadow-[0_12px_26px_rgba(15,23,42,0.12)];\n  }\n\n  .sm-empty {\n    @apply flex flex-col items-center justify-center gap-2 rounded-[20px] border border-dashed border-[color:var(--sm-border)] bg-[color:var(--sm-surface-muted)] p-6 text-center text-sm text-[color:var(--sm-text-muted)];\n  }\n\n  .sm-modal {\n    @apply rounded-[22px] border border-[color:var(--sm-border)] bg-[color:var(--sm-surface)] p-6 text-[color:var(--sm-text)] shadow-[0_28px_80px_rgba(15,23,42,0.2)];\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
